export default {
    "sidebar": {
        "globalTemplates": "Modèles globaux",
        "profileSaveError": "Erreur lors de l'enregistrement du profil : {{msg}}",
        "mfaDisableError": "La MFA n'a pas pu être désactivée : {{msg}}",
        "title": "CAF Suite",
        "dashboard": "Vue d'ensemble",
        "learningHub": "Centre d'apprentissage",
        "assessments": "Évaluations",
        "prioritization": "Priorisation",
        "admin": "Admin",
        "contentManagement": "Gestion du contenu",
        "user": "Gestion des utilisateurs",
        "settings": "Paramètres",
        "superAdmin": "Gestion des mandants",
        "logout": "Déconnexion",
        "editProfile": "Modifier le profil",
        "menu": "Menu",
        "projectManagement": "Gestion de projet",
        "assessmentSection": "Évaluation",
        "security": "Sécurité",
        "mfaStatus": {
            "active": "Actif",
            "activeEnforced": "Actif (imposé)",
            "notSetup": "Non configuré",
            "disable": "Désactiver",
            "setup": "Configurer"
        },
        "myTasks": "Mes tâches",
        "online": "En ligne",
        "offline": "Hors ligne",
        "eMail": "E-Mail",
        "benachrichtigungen": "Notifications",
        "kommentareErwaehnungen": "Commentaires & mentions",
        "sofortBenachrichtigen": "Notifier immédiatement",
        "taeglicheZusammenfassung": "Résumé quotidien",
        "keineEMails": "Pas d'e-mails",
        "erinnerungen": "Rappels",
        "faelligeAufgabenMassnahmen": "Tâches & mesures échues",
        "erhaltenSieEMailsWenn": "Recevez des e-mails lorsqu'une date de rappel est atteinte.",
        "ihrName": "Votre nom",
        "mfaDeaktivieren": "Désactiver MFA ?",
        "mfaDeaktiviert": "MFA désactivé",
        "portfolio": "Portefeuille de projets",
        "languageSettings": "Langue",
        "twoFactorAuth": "Authentification à deux facteurs",
        "mfaDisableConfirmMessage": "Voulez-vous vraiment désactiver l'authentification à deux facteurs ? Votre compte sera moins protégé.",
        "mfaDisableConfirmButton": "Désactiver",
        "mfaDisableSuccessMessage": "L'authentification à deux facteurs a été désactivée avec succès.",
        "assessment": "Évaluations",
        "tasks": "Tâches",
        "userManagement": "Gestion des utilisateurs"
    },
    "header": {
        "dashboard": "Vue d'ensemble",
        "learning": "Centre d'apprentissage",
        "assessment": "Évaluations",
        "prioritization": "Priorisation des potentiels",
        "contentManagement": "Gestion du contenu"
    },
    "login": {
        "navGesamtsicht": "Vue d'ensemble",
        "needToKnowTitle": "Need-to-know entre unités",
        "needToKnowDesc": "Chaque unité organisationnelle ne voit que ses propres données et ce que d'autres ont expressément partagé avec elle. Le serveur applique les règles d'accès, qui sont testées automatiquement avant chaque mise en production.",
        "heroChips": {
            "levels": "Vue d'ensemble à tous les niveaux",
            "topics": "Thèmes transversaux maîtrisés",
            "evidence": "Des décisions bien fondées"
        },
        "levels": {
            "title": "Une plateforme pour tous les niveaux",
            "lead": "Les projets et les évaluations naissent là où le travail se fait. La CAF Suite les amène là où l'on décide – sans collectes manuelles ni diapositives de statut.",
            "aggregateTitle": "Consolider les évaluations",
            "aggregateDesc": "Chaque unité s'auto-évalue et décide quand elle partage son résultat avec l'unité supérieure. Celle-ci voit la moyenne de ses unités subordonnées, année après année. Les comparaisons n'apparaissent qu'à partir de trois unités – ainsi, l'auto-évaluation reste sincère.",
            "promoteTitle": "Transmettre les projets",
            "promoteDesc": "Ce qui compte au-delà de sa propre unité, la gestion de portefeuille le transmet niveau par niveau : de l'office à la direction, de la direction au canton. L'unité d'origine reste responsable, et chaque niveau priorise selon ses propres critères. On sait toujours qui a transmis quoi et quand.",
            "topicsTitle": "Piloter les thèmes transversaux",
            "topicsDesc": "Informatique, durabilité, géodonnées : grâce à un thème transversal, le service compétent voit tous les projets concernés, quelle que soit la direction dont ils proviennent. Les doublons apparaissent tôt et les capacités peuvent être planifiées. Avant l'enregistrement, la CAF Suite indique qui obtiendra un droit de regard.",
            "needToKnowLabel": "Need-to-know :",
            "needToKnowDesc": "Chaque unité est propriétaire de ses données. Les autres ne voient que ce qui a été expressément partagé – une règle appliquée sur le serveur, pas seulement dans l'interface.",
            "growLabel": "Commencer petit, grandir ensuite :",
            "growDesc": "Une direction peut démarrer seule et rejoindre plus tard l'organisation entière, sans perte de données."
        },
        "emailPlaceholder": "nom@organisation.ch",
        "passwordRequired": "Le mot de passe est obligatoire",
        "linkingWrongPassword": "Mot de passe incorrect. Veuillez réessayer.",
        "linkingTooManyRequests": "Trop de tentatives. Votre compte a été temporairement bloqué. Veuillez réinitialiser votre mot de passe.",
        "linkingFailed": "Échec de la liaison des comptes.",
        "mfaNoSupportedFactor": "Aucun second facteur pris en charge n'a été trouvé.",
        "linkingAccountExists": "Vous essayez de vous connecter avec SSO pour la première fois, mais votre adresse e-mail <strong>{{email}}</strong> est déjà enregistrée avec un compte à mot de passe.",
        "linkingEnterOldPassword": "Veuillez saisir <strong>une dernière fois votre ancien mot de passe</strong> afin de lier les deux méthodes de connexion en toute sécurité. Vous pourrez ensuite vous connecter facilement via SSO.",
        "authErrors": {
            "invalidCredentials": "La connexion a échoué. Veuillez vérifier votre adresse e-mail et votre mot de passe.",
            "tooManyRequests": "Trop de tentatives. Le compte a été temporairement bloqué. Veuillez réessayer plus tard.",
            "network": "Erreur de connexion. Veuillez vérifier votre connexion Internet.",
            "unexpected": "Une erreur inattendue s'est produite.",
            "invalidEmail": "Format d'adresse e-mail non valide.",
            "resetFailed": "L'e-mail n'a pas pu être envoyé. Veuillez réessayer plus tard."
        },
        "oeffentlicheVerwaltung": "administration publique :",
        "introText": "La CAF Suite relie l'auto-évaluation CAF au pilotage de vos projets – de l'office à la direction, jusqu'à l'organisation entière. Chaque unité travaille de manière autonome. Le niveau supérieur voit des résultats consolidés et les projets qui le concernent. Les services spécialisés comme l'informatique gardent une vue d'ensemble de leurs thèmes transversaux dans toutes les directions.",
        "managementIntro": "Dans le quotidien intense de l'administration publique, il est souvent difficile de maintenir le cap stratégique. La CAF Suite offre à la direction la sécurité de développer l'organisation de manière professionnelle.",
        "managementQuote": "«Mieux vaut se concentrer sur quelques initiatives correctes – et les mener à bien avec succès.»",
        "pillar1Desc": "Utilisez le modèle CAF européen éprouvé pour des auto-évaluations et des évaluations externes structurées. Au lieu de vous fier à des jugements subjectifs, vous vous appuyez sur des données fiables pour identifier avec précision les points forts et les potentiels d'amélioration de votre organisation, dans chaque unité et de façon consolidée pour le niveau supérieur.",
        "pillar2Desc": "Tout ne peut pas être fait en même temps. Notre outil de priorisation vous aide, vous et votre équipe, à classer les potentiels identifiés par pertinence et urgence. Vous prenez ainsi des décisions fondées en matière de ressources et de budget et concentrez vos efforts là où ils ont le plus d'impact.",
        "pillar3Title": "Réaliser les stratégies : Portefeuille & Gestion de projet",
        "pillar3Desc": "Transformez les potentiels en succès mesurables. Le portefeuille de projets intégré montre à chaque niveau les initiatives qu'il doit piloter – de sa propre unité jusqu'à l'organisation entière. Pilotez vos projets à l'aide de feuilles de route détaillées, de vues matricielles et de Pulse Checks (feux pour les délais, les coûts, les ressources et la qualité). La gestion intégrée des tâches et des tableaux garantit que l'équipe traite les tâches de manière maîtrisée et respecte les délais.",
        "pillar4Title": "Développer les compétences : Centre d'apprentissage & Boîte à méthodes",
        "pillar4Desc": "Donnez à vos collaborateurs les moyens d'agir : le Centre d'apprentissage intégré offre un accès rapide à des méthodes éprouvées pour chaque critère CAF. Qu'il s'agisse de feedback à 360 degrés, de cercles de direction agiles ou de Balanced Scorecard, la boîte à méthodes fournit le savoir-faire nécessaire là où on en a besoin.",
        "sicherheitUndDatenschutz": "Sécurité & Protection des données",
        "securityIntro": "Les plus hauts standards pour les autorités. Notre infrastructure est conçue pour la protection, la souveraineté et la conformité.",
        "iacAudit": "Infrastructure as Code (IaC) – entièrement auditable",
        "isdsDesc": "Nous fournissons un modèle complet de concept ISMS avec tous les éléments essentiels.",
        "kontenVerknuepfenBtn": "Lier les comptes",
        "sso": {
            "lookupAppCheck": "La vérification de sécurité du navigateur n'est pas encore terminée ; la connexion via votre organisation (SSO) n'a donc pas pu être vérifiée. Veuillez réessayer dans quelques secondes ou recharger la page.",
            "lookupFailed": "La connexion via votre organisation (SSO) n'a pas pu être vérifiée. Veuillez réessayer.",
            "linkPrepareFailed": "Le compte existe déjà, mais la liaison n'a pas pu être préparée.",
            "popupClosed": "La fenêtre de connexion a été fermée.",
            "popupBlocked": "Le navigateur a bloqué la fenêtre de connexion. Veuillez autoriser les fenêtres contextuelles pour ce site.",
            "orgLoginButton": "Se connecter avec l'organisation (SSO)",
            "domainDetected": "Votre organisation ({{tenantName}}) utilise l'authentification unique.",
            "domainDetectedHint": "Cliquez sur «Se connecter» pour vous connecter via votre compte d'organisation.",
            "ssoError": "Échec de la connexion SSO. Veuillez réessayer.",
            "ssoLoading": "Démarrage SSO...",
            "checkingDomain": "Vérification de l'organisation...",
            "fallbackHint": "Ou connectez-vous avec e-mail et mot de passe",
            "providerNotFound": "Fournisseur SSO non configuré."
        },
        "passwortZuruecksetzen": "Réinitialiser le mot de passe",
        "willkommenZurueck": "Bienvenue",
        "wirSendenIhnenEinenLink": "Nous vous enverrons un lien par e-mail.",
        "bitteMeldenSieSichAn": "Veuillez vous connecter avec votre compte d'autorité.",
        "verarbeite": "Traitement en cours...",
        "linkAnfordern": "Demander le lien",
        "anmelden": "Se connecter",
        "funktionen": "Fonctionnalités",
        "sicherheit": "Sécurité",
        "kontakt": "Contact",
        "kontinuierlicheOrganisationsentwicklung": "Développement organisationnel continu",
        "exzellenzFuerDie": "Excellence pour l'",
        "heroSubline": "De l'analyse à la mise en œuvre – à tous les niveaux.",
        "eMailVersendet": "E-mail envoyé !",
        "bittePruefenSieIhrenPosteingang": "Veuillez vérifier votre boîte de réception pour les instructions.",
        "zurueckZumLogin": "Retour à la connexion",
        "eMailAdresse": "Adresse e-mail",
        "passwort": "Mot de passe",
        "passwortVergessen": "Mot de passe oublié ?",
        "abbrechen": "Annuler",
        "tlsConnection": "Connexion chiffrée (TLS)",
        "souveraenFuehrenFundiertEntscheidenSicher": "Diriger avec assurance. Décider sur la base de faits. Mettre en œuvre en toute sécurité.",
        "die4SaeulenDerOrganisatorischen": "Les 4 piliers du développement organisationnel",
        "evidenzStattBauchgefuehlDieDigitale": "Des preuves plutôt que des intuitions : l'évaluation numérique",
        "fokusAufDasWesentlicheIntelligente": "Focus sur l'essentiel : priorisation intelligente",
        "dieCafSuiteImEinsatz": "La CAF Suite en action",
        "dataLocationTitle": "Données métier en Suisse",
        "dataLocationDesc": "Les évaluations, projets et mesures sont stockés et traités dans des centres de données Google Cloud certifiés ISO à Zurich. Les fonctions d'IA optionnelles utilisent des centres de données situés dans l'UE.",
        "encryptionTitle": "Chiffrement en transit et au repos",
        "encryptionDesc": "Chiffrement TLS lors de la transmission et chiffrement AES-256 des données stockées.",
        "dataProtectionTitle": "Protection des données selon la LPD et le RGPD",
        "dataProtectionDesc": "La CAF Suite est conçue pour la loi fédérale sur la protection des données (LPD) et le règlement général de l'UE sur la protection des données (RGPD). Nous proposons des accords de traitement des données (DPA) pour les autorités.",
        "technischeStandards": "Standards techniques",
        "webApplicationFirewallWafMit": "Pare-feu applicatif Web (WAF) avec Cloud Armor",
        "wcagCompliance": "Accessibilité conforme WCAG 2.1 AA",
        "ciCdPipelineMitAutomatisierten": "Pipeline CI/CD avec contrôles de sécurité automatisés",
        "singleSignOnSsoVia": "Authentification unique (SSO) via SAML 2.0 / OIDC / Microsoft Entra ID",
        "zweiFaktorAuthentifizierungTotp": "Authentification à deux facteurs (TOTP)",
        "taeglicheAutomatisierteBackups": "Sauvegardes automatisées quotidiennes",
        "auditLoggingRelevanterAenderungen": "Journalisation des modifications pertinentes",
        "isdsKonzept": "Concept ISMS :",
        "habenSieFragenOderWuenschen": "Vous avez des questions ou souhaitez une démonstration ?",
        "contactTeaserText": "Nous vous présentons volontiers la CAF Suite avec une organisation type sur trois niveaux – de l'office au canton.",
        "kontaktAufnehmen": "Nous contacter",
        "impressum": "Mentions légales",
        "datenschutz": "Politique de confidentialité",
        "hilfe": "Aide",
        "privateDigital": "PRIVATE DIGITAL",
        "johannesSpring": "Johannes Spring",
        "voiaCumpogna1": "Voia Cumpogna 1",
        "schweiz": "Suisse",
        "eMail": "E-Mail :",
        "haftungshinweisTrotzSorgfaeltigerInhaltlicherKontrolle": "Avertissement : malgré un contrôle minutieux du contenu, nous déclinons toute responsabilité pour le contenu des liens externes.",
        "wieErstelleIchEinenNeuen": "Comment créer un nouvel utilisateur ?",
        "benutzerKoennenNurVonAdministratoren": "Les utilisateurs ne peuvent être invités que par les administrateurs de votre organisation. Veuillez vous adresser à votre service informatique ou au chef de projet CAF de votre administration.",
        "technischerSupport": "Support technique",
        "beiTechnischenProblemenOderFehlermeldungen": "Nous sommes heureux de vous aider pour les problèmes techniques ou messages d'erreur.",
        "supportKontaktieren": "Contacter le support",
        "kontoVerknuepfen": "Lier le compte",
        "ihreEMailAdresseExistiert": "Votre adresse e-mail existe déjà.",
        "sieVersuchenSichDasErste": "Vous essayez de vous connecter avec SSO pour la première fois, mais votre adresse e-mail",
        "bitteGebenSie": "Veuillez saisir",
        "bisherigesPasswort": "Mot de passe actuel",
        "verknuepfe": "Liaison en cours...",
        "datenschutzerklaerung": "Déclaration de protection des données",
        "hilfeSupport": "Aide & Support",
        "alleRechteVorbehalten": "© {{year}} PRIVATE DIGITAL Johannes Spring. Tous droits réservés.",
        "hilfePasswortText": "Cliquez sur «Mot de passe oublié» sur la page de connexion pour recevoir un lien de réinitialisation par e-mail.",
        "carousel": {
            "portfolioSharing": "Transmission d'un projet entre les niveaux",
            "topicRoadmap": "Feuille de route d'un thème transversal",
            "assessmentAggregate": "Agrégat des unités subordonnées",
            "portfolioChart": "Portefeuille de projets – Vue matricielle",
            "portfolioTimeline": "Portefeuille de projets – Feuille de route",
            "selectProject": "Sélection de projet",
            "projectDetails": "Détails du projet",
            "tasks": "Tableau des tâches (Kanban)",
            "myTasks": "Mes tâches",
            "assessmentOverview": "Aperçu de l'évaluation",
            "assistent": "Assistant d'évaluation",
            "criteria": "Informations sur le modèle",
            "methods": "Boîte à méthodes"
        }
    },
    "finishassessorregistration": {
        "keinGueltigerLink": "Aucun lien valide trouvé.",
        "einladungslinkUngueltig": "Le lien d'invitation a expiré ou est invalide.",
        "speichere": "Enregistrement...",
        "registrierungAbschliessenBtn": "Terminer l'inscription",
        "linkUngueltig": "Lien invalide",
        "zurueckZumLogin": "Retour à la connexion",
        "registrierungAbschliessen": "Terminer l'inscription",
        "vervollstaendigenSieIhrProfilFuer": "Complétez votre profil pour ",
        "ihrName": "Votre nom",
        "firmaOrganisation": "Entreprise / Organisation",
        "passwort": "Mot de passe",
        "wiederholen": "Répéter",
        "vornameNachname": "Prénom, Nom",
        "consultingGmbh": "Consulting Sàrl",
        "esIstEinFehlerAufgetreten": "Une erreur s'est produite. Veuillez réessayer.",
        "erfolgreich": "Succès !",
        "abschlussFehlgeschlagen": "Finalisation échouée.",
        "dieRegistrierungWarErfolgreichSie": "Inscription réussie. Vous allez être redirigé..."
    },
    "setpassword": {
        "passwortZuruecksetzen": "Réinitialiser le mot de passe",
        "resetText": "Définissez un nouveau mot de passe. Vous pourrez ensuite vous connecter avec votre adresse e-mail et ce nouveau mot de passe.",
        "neuesPasswortFestlegen": "Définir un nouveau mot de passe",
        "linkUngueltig": "Lien invalide",
        "passwoerterStimmenNichtUeberein": "Les mots de passe ne correspondent pas",
        "linkUngueltigOderAbgelaufen": "Le lien est invalide ou a expiré.",
        "linkAbgelaufen": "Le lien a expiré.",
        "linkAbgelaufenOderVerwendet": "Le lien a expiré ou a déjà été utilisé.",
        "passwortZuSchwach": "Le mot de passe est trop faible.",
        "fehlerAufgetreten": "Une erreur s'est produite. Veuillez réessayer.",
        "supportHinweis": "En cas de problème technique ou de message d'erreur, veuillez envoyer un e-mail avec une capture d'écran et une description à support@caf-suite.ch.",
        "fuer": "pour {{email}}",
        "gebenSieIhrNeuesPasswortEin": "Saisissez votre nouveau mot de passe.",
        "speichern": "Enregistrement...",
        "passwortSpeichern": "Enregistrer le mot de passe",
        "einladungAnnehmen": "Accepter l'invitation",
        "accountAktivierung": "Activation du compte",
        "willkommenBeiDer": "Bienvenue sur",
        "cafSuite": "CAF Suite.",
        "bitteLegenSieEinSicheres": "Veuillez définir un mot de passe sécurisé pour activer votre compte.",
        "passwortFestlegen": "Définir le mot de passe",
        "erfolgreich": "Succès !",
        "ihrPasswortWurdeGespeichertSie": "Votre mot de passe a été enregistré. Vous allez être redirigé...",
        "neuesPasswort": "Nouveau mot de passe",
        "passwortBestaetigen": "Confirmer le mot de passe",
        "sichereSslVerschluesselung": "Chiffrement SSL sécurisé",
        "impressum": "Mentions légales",
        "datenschutz": "Politique de confidentialité",
        "hilfe": "Aide",
        "privateDigital": "PRIVATE DIGITAL",
        "johannesSpring": "Johannes Spring",
        "voiaCumpogna1": "Voia Cumpogna 1",
        "schweiz": "Suisse",
        "eMail": "E-Mail :",
        "haftungshinweisTrotzSorgfaeltigerInhaltlicherKontrolle": "Avertissement : malgré un contrôle minutieux, nous déclinons toute responsabilité pour le contenu des liens externes.",
        "datenschutzerklaerung": "Déclaration de protection des données",
        "hilfeSupport": "Aide & Support"
    },
    "contact": {
        "companyRequired": "L'organisation est obligatoire pour les demandes de devis et de démonstration",
        "title": "Nous contacter",
        "topic": "Sujet",
        "topics": {
            "general": "Renseignement général",
            "quote": "Demande de devis",
            "demo": "Demande de démonstration",
            "support": "Support"
        },
        "name": "Nom",
        "email": "E-Mail",
        "organization": "Organisation",
        "phone": "Téléphone (facultatif)",
        "subject": "Objet",
        "subjectPlaceholders": {
            "quote": "Demande de devis pour...",
            "demo": "Demande de démo pour...",
            "support": "Problème avec...",
            "general": ""
        },
        "message": "Message",
        "send": "Envoyer",
        "sending": "Envoi en cours...",
        "successTitle": "Merci !",
        "successMessage": "Nous avons bien reçu votre message et vous répondrons dans les meilleurs délais.",
        "close": "Fermer",
        "backendError": "Backend indisponible",
        "genericError": "Une erreur s'est produite. Veuillez réessayer ultérieurement."
    },
    "privacycontent": {
        "allgemeines": "1. Généralités",
        "derSchutzIhrerDatenHat": "La protection de vos données est notre priorité absolue. Nous traitons les données personnelles exclusivement dans le cadre des dispositions légales (RGPD, LPD).",
        "datenerhebungBeiNutzung": "2. Collecte de données lors de l'utilisation",
        "wennSieUnsereSoftwareNutzen": "Lorsque vous utilisez notre logiciel, nous collectons les données techniquement nécessaires suivantes :",
        "ipAdresse": "Adresse IP",
        "datumUndUhrzeitDerAnfrage": "Date et heure de la demande",
        "inhaltDerAnforderungKonkreteSeite": "Contenu de la demande (page spécifique)",
        "browserUndBetriebssystem": "Navigateur et système d'exploitation",
        "benutzerkonten": "3. Comptes utilisateurs",
        "fuerDieNutzungDerApp": "Un compte utilisateur est nécessaire pour utiliser l'application. Nous y stockons votre adresse e-mail, votre nom (facultatif) et votre affiliation à une organisation.",
        "ihreRechte": "4. Vos droits",
        "ihreRechteText": "Vous avez le droit de demander des informations, une correction, une suppression et une limitation du traitement de vos données. Veuillez contacter notre responsable de la protection des données à datenschutz@caf-suite.ch.",
        "kiFunktionen": "5. Fonctions d'IA (optionnelles)",
        "kiFunktionenText": "La CAF Suite propose des fonctions d'IA optionnelles, par exemple des suggestions de projets ou une synthèse pour la direction. Votre organisation peut les désactiver à tout moment ; aucune donnée n'est alors transmise au service d'IA. Lorsqu'une fonction est activée, la CAF Suite envoie à Google Vertex AI uniquement les contenus dont elle a besoin (p. ex. les notes et remarques d'une évaluation ou le texte d'un potentiel). Les noms et adresses e-mail des comptes utilisateurs ne sont pas transmis. Le traitement a lieu dans des centres de données situés dans l'UE, et non en Suisse. Google n'utilise pas les données pour entraîner ses modèles, mais peut journaliser les requêtes afin de détecter les abus. La CAF Suite n'enregistre les réponses que si vous reprenez une suggestion.",
        "hinweisZurCloudNutzung": "6. Note sur l'utilisation du cloud & données personnelles",
        "dieDatenWerdenInGoogle": "Les données sont stockées dans les centres de données Google Cloud (Zurich).",
        "empfehlungDieseAppDientDer": "Recommandation : Cette application est destinée à l'analyse organisationnelle stratégique (CAF). Veuillez ne pas saisir de données personnelles sensibles de citoyens."
    },
    "mfa": {
        "setupTitle": "Configurer l'authentification à 2 facteurs",
        "setupSubtitle": "Renforcez la sécurité de votre compte",
        "scanStep": "1. Scanner le code",
        "appInstruction": "Ouvrez votre application d'authentification (Google Authenticator, Microsoft Authenticator, etc.) et scannez ce code.",
        "verifyStep": "2. Confirmer",
        "enterCode": "Saisissez le code à 6 chiffres",
        "verifyButton": "Vérifier",
        "successMessage": "MFA configuré avec succès !",
        "errorInvalidCode": "Code invalide. Veuillez réessayer.",
        "setupError": "Erreur lors de la configuration de l'authentification à 2 facteurs. Veuillez recharger la page.",
        "verificationTitle": "Confirmer l'authentification à 2 facteurs",
        "verificationIntro": "Saisissez le code à 6 chiffres de votre application d'authentification pour confirmer votre identité.",
        "emailNotVerified": "E-mail non vérifié",
        "emailNotVerifiedMessage": "Votre adresse e-mail doit être vérifiée avant de pouvoir configurer la 2FA. Veuillez vérifier votre boîte de réception ou demander un nouvel e-mail.",
        "resendVerification": "Renvoyer l'e-mail de vérification",
        "verificationSent": "E-mail envoyé ! Veuillez vérifier votre boîte de réception.",
        "verifyError": "Le code est invalide. Veuillez réessayer.",
        "mfaNotActivated": "La MFA n'est pas encore activée pour ce projet (Identity Platform). Veuillez contacter votre administrateur.",
        "emailNotVerifiedShort": "E-mail non vérifié.",
        "recentLoginRequired": "Délai de sécurité : veuillez vous reconnecter pour configurer la 2FA.",
        "sendEmailError": "Erreur lors de l'envoi de l'e-mail : ",
        "activated": "2FA activé !",
        "enforcedNotice": "Votre organisation exige un second facteur. Sans configuration, vous ne pouvez pas utiliser CAF Suite. Vous pouvez annuler et vous déconnecter ; vous reprendrez ici à la prochaine connexion.",
        "cancelAndLogout": "Annuler et se déconnecter",
        "activatedShort": "2FA activé",
        "verifying": "Vérification..."
    },
    "dashboard": {
        "brushRange": "Période du {{start}} au {{end}}",
        "overallScore": "Score global",
        "overallScoreDate": "Score global ({{date}})",
        "activeMeasures": "Mesures actives",
        "assessmentTrend": "Vue d'ensemble des évaluations",
        "compareLast": "Comparer les dernières :",
        "assessments": "{{count}} Évaluations",
        "breakdown": "Analyse détaillée",
        "breakdownDate": "Analyse détaillée ({{date}})",
        "noAssessmentData": "Aucune donnée d'évaluation pour la date sélectionnée.",
        "vs": "vs.",
        "startNewAssessment": "Démarrer une nouvelle évaluation",
        "notAvailable": "N/D",
        "welcome": {
            "title": "Bienvenue dans votre CAF Suite !",
            "message": "Voici votre tableau de bord pour l'amélioration continue. Utilisez le module d'auto-évaluation pour mener de nouvelles évaluations.",
            "cta": "Aller au module d'évaluation"
        },
        "kpi": {
            "score": "Score actuel",
            "scoreSub": "Moyenne (Total)",
            "potentials": "Nombre de potentiels",
            "potentialsSub": "De l'évaluation actuelle",
            "addressed": "Potentiels mis en œuvre",
            "addressedSub": "Couverts par un projet"
        },
        "compareWith": "Comparer avec :",
        "subtitle": "Votre cockpit pour l'amélioration continue.",
        "selectOrgScope": "Unité organisationnelle / Évaluation",
        "scopeOwn": "Propre organisation",
        "scopeRollup": "Vue consolidée (Rollup)",
        "noSharedAssessmentsTitle": "Aucune évaluation partagée",
        "noSharedAssessmentsMsg": "Cette unité organisationnelle n'a pas encore partagé d'auto-évaluation pour examen hiérarchique.",
        "tabs": {
            "nav": "Onglets",
            "status": "Vue d'ensemble du statut",
            "trends": "Tendances à long terme"
        },
        "analysis": {
            "title": "Développement à long terme",
            "filter": "Filtre d'analyse",
            "filterSeries": "Filtrer les séries de données",
            "filterCriteria": "Filtrer les critères (des thèmes actifs)",
            "topImprovers": "Top 3 améliorations",
            "topDecliners": "Top 3 baisses",
            "reset": "Réinitialiser",
            "highlights": "Points forts de la période",
            "topDevelopments": "Meilleures évolutions",
            "biggestDeclines": "Plus grandes baisses",
            "table": {
                "criterion": "Critère",
                "current": "Actuel",
                "trend": "Tendance",
                "compare": "Comparaison"
            },
            "chart": {
                "themePrefix": "Th.",
                "total": "Total"
            }
        },
        "export": {
            "title": "Exporter le rapport",
            "button": "Exporter le rapport",
            "subtitle": "Sélectionnez le contenu à exporter.",
            "csv": "Exporter en CSV",
            "pdf": "Créer un PDF",
            "trendAnalysis": "Analyse à long terme",
            "trendDescription": "Ajoute une analyse du développement sur plusieurs évaluations.",
            "aiAnalysis": "Analyse IA",
            "aiDescription": "Génère un résumé de direction et des analyses par thème.",
            "aiDisabled": "Cette fonctionnalité a été désactivée par votre administrateur.",
            "question": "Quel contenu doit être inclus dans le rapport actuel ?",
            "overview": "Vue d'ensemble de l'évaluation",
            "overviewDesc": "Ajoute la vue d'ensemble de l'évaluation (tuiles et graphique radar) au rapport.",
            "trendAnalysisDesc": "Ajoute le graphique à long terme, ainsi que le Top 3 améliorations et le Top 3 baisses.",
            "generating": "Génération en cours...",
            "chartLoading": "Chargement du graphique..."
        },
        "errorLoadingData": "Erreur lors du chargement des données.",
        "scopeOwnShort": "propres évaluations",
        "scopeAggregate": "Agrégat des {{children}}",
        "scopeReleased": "évaluations partagées"
    },
    "learning": {
        "removeFromFavorites": "Retirer des favoris",
        "favorites": { "title": "Voir les favoris" },
        "cafCriteria": "Thèmes & Critères CAF",
        "myFavorites": "Mes favoris",
        "selectSubCriterion": "Sélectionnez un critère pour afficher les détails.",
        "bestPractices": "Exemples",
        "aiSuggestions": "Suggestions IA",
        "generateIdeas": "Générer de nouvelles idées",
        "generating": "Génération en cours...",
        "createAction": "Créer un projet",
        "creating": "Création en cours...",
        "addToFavorites": "Ajouter aux favoris",
        "favoritesModalTitle": "Mes favoris",
        "noFavorites": "Vous n'avez pas encore ajouté de favoris.",
        "noFavoritesHint": "Cliquez sur l'icône étoile à côté d'un critère ou d'une méthode pour l'enregistrer ici.",
        "subtitle": "Base de connaissances & méthodes pour une administration d'excellence.",
        "tabs": {
            "knowledge": "Modèle & Critères",
            "methods": "Boîte à méthodes"
        },
        "sections": {
            "themes": "Thèmes et critères"
        },
        "methods": {
            "searchPlaceholder": "Rechercher des méthodes...",
            "resetTooltip": "Réinitialiser les filtres",
            "reset": "Réinitialiser",
            "allThemes": "Tous les thèmes",
            "allCriteria": "Tous les critères",
            "shortDescription": "Description courte",
            "tips": "Conseils & Instructions",
            "reference": "Référence :",
            "adoptAction": "Créer un projet",
            "introTitle": "Introduction à la méthode"
        },
        "favoriteCriteria": "Critères favoris",
        "favoriteMethods": "Méthodes favorites"
    },
    "validation": {
        "titleRequired": "Le titre est obligatoire",
        "descriptionRequired": "La description est obligatoire",
        "required": "Ce champ est obligatoire",
        "email": "Veuillez saisir une adresse e-mail valide",
        "minLength": "Au moins {{min}} caractères requis",
        "nameRequired": "Le nom est obligatoire",
        "orgRequired": "Le nom de l'organisation est obligatoire",
        "roleRequired": "Le rôle est obligatoire",
        "startDateBeforeDueDate": "La date de début ne doit pas être postérieure à la date d'échéance",
        "reminderBeforeDueDate": "La date de rappel ne doit pas être postérieure à la date d'échéance"
    },
    "components": {
        "labelColon": "{{label}} :",
        "toggleDropdown": "Ouvrir ou fermer la liste déroulante",
        "selectPlaceholder": "Sélectionner...",
        "noOptions": "Aucune option disponible",
        "datePlaceholder": "Sélectionner une date",
        "weekdays": ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
        "monthNames": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        "today": "Aujourd'hui",
        "clearDate": "Effacer",
        "prevMonth": "Mois précédent",
        "nextMonth": "Mois suivant",
        "prevYear": "Année précédente",
        "nextYear": "Année suivante"
    },
    "assessment": {
        "scoreShort": {
            "enabler": {
                "noEvidence": "Aucune preuve",
                "plan": "PLAN",
                "do": "DO",
                "check": "CHECK",
                "act": "ACT",
                "excellence": "EXCELLENCE"
            },
            "result": {
                "noResults": "Aucun résultat",
                "negativeTrends": "Tendances négatives",
                "stable": "Stable",
                "improvement": "Amélioration",
                "targetsMet": "Objectifs atteints",
                "excellence": "Excellence"
            }
        },
        "submitConfirmMessage": "Voulez-vous vraiment soumettre cette évaluation ? Elle sera visible pour le mandant et ne pourra plus être modifiée.",
        "bemerkungLoeschenFrage": "Voulez-vous vraiment supprimer définitivement cette remarque ?",
        "targetTenantPrompt": "Veuillez saisir l'ID du mandant cible (Client ID) :",
        "reportByAuthor": "Rapport de {{name}}",
        "selfAssessmentsWithReleased": "Auto-évaluations",
        "selfAssessmentsWithReleasedIntro": "Vos propres auto-évaluations et celles que les unités subordonnées vous ont partagées (lecture seule).",
        "filters": {
            "allClients": "Tous les mandants",
            "all": "Tous",
            "draft": "Brouillon (Ouvert)",
            "published": "Publié"
        },
        "enablerScores": {
            "0-10": "Aucune preuve ou approche disponible.",
            "11-30": "PLAN : Il y a des plans ou des idées, mais pas encore de mise en œuvre systématique.",
            "31-50": "DO : Les approches sont mises en œuvre dans les domaines pertinents.",
            "51-70": "CHECK : La mise en œuvre est régulièrement vérifiée et mesurée.",
            "71-90": "ACT : Sur la base des évaluations, des améliorations sont apportées.",
            "91-100": "EXCELLENCE : Modèle de référence, benchmark, amélioration continue."
        },
        "resultScores": {
            "0-10": "Aucun résultat mesuré ou disponible.",
            "11-30": "Tendances négatives ou objectifs non atteints.",
            "31-50": "Résultats stables ou légères améliorations.",
            "51-70": "Tendances positives identifiables sur plusieurs années.",
            "71-90": "Objectifs atteints/dépassés, comparaisons positives.",
            "91-100": "Position dominante de premier plan constamment maintenue."
        },
        "manageAssessments": "Mener une évaluation",
        "ownSelfAssessment": "Auto-évaluation propre",
        "ownSelfAssessments": "Propres auto-évaluations",
        "ownSelfAssessmentsIntro": "Gérez vos propres auto-évaluations ou lancez un nouveau cycle.",
        "unassignedBannerTitle": "Évaluations non assignées trouvées",
        "unassignedBannerDesc": "{{count}} évaluations de cycles précédents sans unité organisationnelle ont été trouvées. Assignez-les maintenant à votre unité ({{unitName}}) :",
        "assignToMyUnitBtn": "Assigner à {{unitName}} maintenant",
        "assignSuccessMessage": "Toutes les évaluations précédentes ont été assignées avec succès à votre unité organisationnelle et marquées comme confidentielles.",
        "assignErrorMessage": "Erreur lors de l'assignation des évaluations.",
        "rollupDashboardTab": "Tableau de bord consolidé (Rollup)",
        "selectOrgUnitRollup": "Unité organisationnelle pour la consolidation",
        "assessmentOverview": "Vue d'ensemble des évaluations",
        "assessmentOverviewIntro": "Gérez vos auto-évaluations et évaluations externes ou démarrez un nouveau cycle.",
        "newAssessment": "Nouvelle évaluation",
        "assessmentFrom": "Évaluation du :",
        "deleteAssessment": "Supprimer l'évaluation",
        "duplicate": "Dupliquer",
        "duplicatedMessage": "Évaluation dupliquée. Vous pouvez maintenant apporter des modifications et enregistrer.",
        "implementedPrefix": "Mis en œuvre : ",
        "forTenant": "Pour le mandant",
        "submitErrorTitle": "Erreur de soumission",
        "noAssessmentsFound": "Aucune évaluation trouvée. Démarrez votre première auto-évaluation maintenant.",
        "resultsOverview": "Vue d'ensemble des résultats de l'évaluation",
        "view": "Affichage :",
        "compareWith": "Comparer avec :",
        "none": "Aucun (actuel uniquement)",
        "detailedAssessment": "Évaluation détaillée",
        "detailedAssessmentDate": "Évaluation détaillée ({{date}})",
        "addComment": "Ajouter un commentaire...",
        "selectOrNew": "Veuillez sélectionner une évaluation pour afficher les détails, ou en créer une nouvelle.",
        "assessmentExists": "Une évaluation pour aujourd'hui existe déjà.",
        "showScoringGuide": "Afficher la méthodologie & le guide de notation",
        "backToOverview": "Retour à la vue d'ensemble",
        "resetScores": "Réinitialiser les scores",
        "selfAssessment": "Auto-évaluation",
        "externalAssessment": "Évaluation externe",
        "externalAssessmentIntro": "Historique et gestion de vos évaluations externes.",
        "publish": "Publier",
        "published": "Publié",
        "draft": "Brouillon",
        "managementSummary": "Synthèse",
        "criterionRemark": "Remarque sur le thème",
        "noExternalAssessments": "Vous n'avez pas encore créé d'évaluations externes.",
        "readOnly": "Lecture seule",
        "publishConfirmTitle": "Publier l'évaluation ?",
        "publishConfirmMessage": "Elle sera visible par tous les utilisateurs de l'organisation. Continuer ?",
        "assessmentWizard": "Assistant d'évaluation",
        "hideAssessment": "Masquer l'évaluation",
        "unhideAssessment": "Afficher l'évaluation",
        "showHidden": "Afficher les masqués",
        "hidden": "Masqué",
        "achtung": "Attention :",
        "folgendeKriterienWurdenImAktuellen": "Les critères suivants ont été modifiés dans le modèle actuel et doivent être entièrement réévalués :",
        "einreichen": "Soumettre",
        "wirdGespeichert": "Enregistrement...",
        "hinzufuegen": "Ajouter",
        "mandant": "Mandant",
        "status": "Statut",
        "alsCsvExportieren": "Exporter en CSV",
        "alsPdfExportieren": "Exporter en PDF",
        "bewertungEinreichen": "Soumettre l'évaluation",
        "fassenSieDieWichtigstenErgebnisse": "Résumez les principaux résultats et recommandations...",
        "fakultativeBemerkungZuDiesemThemenfeld": "Remarque facultative sur ce thème...",
        "massnahmeErstellen": "Créer une mesure",
        "bearbeiten": "Modifier",
        "loeschen": "Supprimer",
        "staerkeVerbesserungspotenzialOderKommentarHinzufuegen": "Ajouter un point fort, un potentiel d'amélioration ou un commentaire...",
        "linkHinzufuegenEntfernen": "Ajouter/supprimer un lien",
        "linkPlaceholder": "https://exemple.ch ou mailto:...",
        "remarkType": "Type",
        "remarkStrength": "Point fort",
        "remarkPotential": "Potentiel",
        "remarkInfo": "Commentaire",
        "bemerkungLoeschen": "Supprimer la remarque",
        "bemerkungBearbeiten": "Modifier la remarque",
        "rated": "évalué(s)",
        "complete": "terminé",
        "fillWithAI": "Remplir avec l'IA",
        "zurueckZurUebersicht": "Retour à la vue d'ensemble",
        "infoZumKriterium": "Info sur le critère",
        "bewertungsassistent": "Assistant d'évaluation",
        "neueBewertung": "Nouvelle évaluation"
    },
    "assessorDashboard": {
        "dabeiSeit": "Assigné le : {{date}}",
        "archiveClient": "Archiver",
        "activateClient": "Activer",
        "title": "Tableau de bord de l'assesseur",
        "subtitle": "Vue d'ensemble de vos mandants et évaluations",
        "kpiClients": "Mandants",
        "kpiAssessments": "Évaluations",
        "kpiDrafts": "Brouillons ouverts",
        "kpiBestScore": "Meilleur score",
        "kpiWorstScore": "Score le plus bas",
        "kpiAvgScore": "Score moyen",
        "showInactive": "Afficher les inactifs",
        "searchPlaceholder": "Rechercher...",
        "noClientsFound": "Aucun mandant trouvé.",
        "statusInactive": "Inactif",
        "actionView": "Voir",
        "tableHeaderClient": "Mandant",
        "tableHeaderDate": "Date",
        "inactiveLabel": "(Inactif)",
        "myClients": "Mes mandants",
        "oldestAssessments": "Évaluations les plus anciennes",
        "never": "Jamais",
        "errorStatusUpdate": "Erreur lors de la mise à jour du statut."
    },
    "prioritization": {
        "loadErrorAssessments": "Erreur lors du chargement des évaluations.",
        "loadErrorPotentials": "Erreur lors du chargement des potentiels d'amélioration.",
        "loadErrorProjects": "Erreur lors du chargement des projets.",
        "intro": "Priorisez les potentiels d'amélioration identifiés par vote d'équipe et urgence (score).",
        "noPotentials": "Aucun potentiel trouvé dans l'évaluation actuelle.",
        "scoreLabel": "Score",
        "votesLabel": "Votes",
        "createAction": "Créer un projet",
        "linkProject": "Lier un projet",
        "projectLinked": "Transféré vers le projet «{{project}}»",
        "projectLinkedDefault": "Transféré vers un projet",
        "linkProjectModalTitle": "Lier un projet",
        "linkProjectModalDesc": "Sélectionnez un projet existant pour intégrer ce potentiel d'amélioration.",
        "existingProject": "Projet existant",
        "searchProject": "Rechercher un projet...",
        "link": "Lier",
        "vote": "Voter",
        "voted": "Voté",
        "highPriority": "Haute priorité",
        "mediumPriority": "Priorité moyenne",
        "lowPriority": "Faible priorité",
        "bereitsUmgesetzteAusblenden": "Masquer les potentiels déjà mis en œuvre",
        "kontext": "Contexte",
        "relevanz": "Pertinence ?",
        "keineAktivenProjekteGefunden": "Aucun projet actif trouvé.",
        "stimmeFuerDieseMassnahmeAbgeben": "Voter pour cette mesure",
        "basis": "Basé sur",
        "noProjectsForQuery": "Aucun projet trouvé pour «{{query}}»."
    },
    "contentManagement": {
        "methodSaveError": "Une erreur inconnue s'est produite (éventuellement lors du téléversement de l'image).",
        "cleanModalMessage": "Voulez-vous vraiment supprimer tous vos propres thèmes, critères et exemples ?",
        "filters": {
            "allThemes": "Tous les thèmes",
            "allCriteria": "Tous les critères"
        },
        "title": "Gestion du contenu",
        "intro": "Gérez et personnalisez la structure, les thèmes et les critères de l'application CAF.",
        "editTitle": "Modifier le titre",
        "editDescription": "Modifier la description",
        "saveChanges": "Enregistrer les modifications",
        "criterionDescription": "Description du thème",
        "subCriteria": "Critères",
        "bestPracticesLabel": "Exemples",
        "bestPracticesPlaceholder": "Saisissez chaque exemple sur une nouvelle ligne.",
        "addSubCriterion": "Ajouter un critère",
        "addCriterion": "Ajouter un nouveau thème",
        "subCriterionDescriptionPlaceholder": "Description du critère...",
        "enabler": "Facteur",
        "result": "Résultat",
        "deleteCriterion": "Supprimer le thème",
        "deleteSubCriterion": "Supprimer le critère",
        "addBestPractice": "Ajouter un exemple",
        "deleteBestPractice": "Supprimer",
        "cleanCustomContent": "Supprimer le contenu personnel",
        "cleanModalTitle": "Supprimer le contenu personnel",
        "newTheme": "Nouveau thème",
        "newCriterion": "Nouveau critère",
        "newExample": "Nouvel exemple",
        "newModule": "Nouveau module",
        "newSection": "Nouvelle section",
        "translation": {
            "readingFile": "Lecture du fichier...",
            "invalidJson": "Format JSON invalide.",
            "unknownFileType": "Type de fichier inconnu. Attendu : fileType «structure» ou «methods».",
            "unsupportedLanguage": "Langue cible non prise en charge : «{{lang}}». Autorisées : en, fr, it.",
            "validatingStructure": "Vérification du fichier de structure...",
            "validatingMethods": "Vérification du fichier des méthodes...",
            "invalidFile": "Fichier invalide : {{detail}}",
            "insertingThemes": "Insertion des traductions des thèmes...",
            "insertingModules": "Insertion des traductions des modules d'information...",
            "insertingMethods": "Insertion des traductions des méthodes...",
            "savingTranslations": "Enregistrement des traductions...",
            "structureImported": "Traduction de la structure ({{lang}}) importée avec succès.",
            "methodsImported": "Traduction des méthodes ({{lang}}) importée avec succès.",
            "importFailed": "Échec de l'import : {{msg}}",
            "openModal": "Exporter / Importer traduction",
            "modalTitle": "Contenus pour traduction",
            "modalSubtitle": "Exportez tous les textes en JSON pour une traduction assistée par IA, puis importez le résultat traduit.",
            "exportTab": "Export",
            "importTab": "Import",
            "targetLanguage": "Langue cible (contexte IA)",
            "importLanguage": "Langue de la traduction",
            "fieldCount": "{{count}} champs de texte seront exportés",
            "exportHint": "Téléchargez le JSON et soumettez-le à une IA avec ce prompt :",
            "aiPrompt": "Traduisez tous les textes de ce JSON en {{language}}. Conservez la structure JSON exacte, toutes les clés et toutes les valeurs des champs _id et _index sans modification.",
            "downloadJson": "Télécharger JSON",
            "importWarningTitle": "Attention",
            "importHint": "Les traductions existantes pour cette langue seront écrasées. Les textes sources en allemand restent inchangés.",
            "importJson": "Importer JSON",
            "importing": "Importation...",
            "fileStructure": "Fichier 1 : Structure CAF & Modules d'information",
            "fileMethods": "Fichier 2 : Boîte à méthodes",
            "importBothHint": "Importez les deux fichiers séparément (fichier structure et fichier méthodes)."
        }
    },
    "superAdmin": {
        "migration": {
            "loadingData": "Chargement des données...",
            "analyzingAssets": "Analyse des fichiers...",
            "packingAsset": "Ajout du fichier {{current}}/{{total}}",
            "creatingZip": "Création du fichier ZIP...",
            "exportDone": "Export terminé. Fichiers sauvegardés : {{n}}.",
            "exportFailedAssets": "ATTENTION : certains fichiers n'ont pas pu être chargés (nombre : {{n}}).\nLa cause est généralement une configuration CORS manquante sur le bucket de stockage.\nVous trouverez les détails dans la console du navigateur.",
            "exportFailed": "Erreur lors de l'export : {{msg}}",
            "analyzingZip": "Analyse du fichier ZIP...",
            "zipMissingData": "ZIP invalide : «data.json» manquant.",
            "isZipFile": "Il s'agit d'un fichier ZIP. Veuillez l'importer en tant que .zip.",
            "noCafStructure": "Données invalides : aucune structure CAF trouvée.",
            "confirmImport": "Importer ? Cette opération écrase les paramètres globaux du système.",
            "assetsWillUpload": "Les fichiers seront téléversés.",
            "importingAssets": "Import des fichiers (terminés : {{n}})...",
            "missingInZip": "Absent du ZIP : {{file}}",
            "processingData": "Traitement des données (cela peut prendre un moment)...",
            "importWarnings": "Import terminé avec des avertissements.\n\nFichiers importés : {{ok}}\nÉchecs : {{failed}}",
            "importDoneAssets": "Import réussi. Fichiers importés : {{n}}.",
            "savingDatabase": "Enregistrement dans la base de données...",
            "importDone": "Données importées avec succès. Veuillez recharger la page.",
            "importFailed": "Échec de l'import : {{msg}}"
        },
        "tenantCreatedSuccess": "Le mandant «{{orgName}}» a été créé. L'administrateur du mandant reçoit une invitation par e-mail.",
        "title": "Gestion des mandants",
        "intro": "Gérez toutes les organisations, leurs licences et leurs accès.",
        "createTenant": "Créer un nouveau mandant",
        "tenantName": "Nom de l'organisation",
        "adminEmail": "E-Mail admin",
        "status": "Statut",
        "plan": "Plan",
        "actions": "Actions",
        "active": "Actif",
        "inactive": "Inactif",
        "created": "Créé le",
        "modalTitle": "Créer un nouveau mandant",
        "toggleStatus": "Changer le statut",
        "createTenantTitle": "Créer un nouveau mandant",
        "createUserTitle": "Inviter un utilisateur",
        "editUserRoleTitle": "Modifier le rôle",
        "deleteTenantTitle": "Supprimer le mandant",
        "deleteTenantMessage": "Êtes-vous sûr ? Cette action supprimera définitivement le mandant et TOUTES les données associées.",
        "deleteTenantConfirmationLabel": "Saisissez le nom de l'organisation pour confirmer :",
        "deleteAssessorTitle": "Supprimer l'assesseur",
        "deleteAssessorMessage": "Êtes-vous sûr ? Cette action supprimera définitivement le compte de l'assesseur.",
        "deleteAssessorConfirmationLabel": "Saisissez l'adresse e-mail pour confirmer :",
        "importExport": "Importer / Exporter des données",
        "exportGlobal": "Exporter le jeu de données global (incl. ressources)",
        "importGlobal": "Restaurer la sauvegarde",
        "importWarning": "Attention : écrase les données actuelles !",
        "fullDelete": "Suppression complète",
        "tenantDeleteButton": "Supprimer complètement le mandant",
        "assessorDeleteButton": "Supprimer complètement l'assesseur",
        "sso": {
            "title": "Authentification unique (SAML 2.0)",
            "description": "Configurez SSO avec Microsoft Entra ID / Azure AD pour ce mandant.",
            "enabled": "SSO activé",
            "disabled": "SSO désactivé",
            "enableToggle": "Activer SAML SSO",
            "displayName": "Nom d'affichage",
            "displayNamePlaceholder": "ex. SSO Ville de Berne",
            "entityId": "ID d'entité IdP",
            "entityIdPlaceholder": "ex. https://sts.windows.net/{tenant-id}/",
            "ssoUrl": "URL de connexion SSO",
            "ssoUrlPlaceholder": "https://login.microsoftonline.com/{tenant-id}/saml2",
            "certificate": "Certificat X.509 (PEM)",
            "certificatePlaceholder": "-----BEGIN CERTIFICATE-----\\n...\\n-----END CERTIFICATE-----",
            "domains": "Domaines SSO",
            "domainsPlaceholder": "ville-berne.ch, commune.ch",
            "domainsHint": "Domaines e-mail séparés par des virgules qui se connecteront via SSO.",
            "save": "Configurer SSO",
            "saving": "Enregistrement...",
            "remove": "Supprimer SSO",
            "removing": "Suppression...",
            "configured": "SSO configuré",
            "notConfigured": "SSO non configuré",
            "saveSuccess": "Configuration SSO enregistrée avec succès.",
            "removeSuccess": "Configuration SSO supprimée.",
            "removeConfirm": "Voulez-vous vraiment désactiver SSO pour ce mandant ? Les utilisateurs devront alors se connecter avec e-mail/mot de passe.",
            "rpEntityId": "ID d'entité SP (facultatif)",
            "rpEntityIdPlaceholder": "Laisser vide pour la génération automatique"
        },
        "assessorDeleted": "L'assesseur «{{email}}» a été définitivement supprimé.",
        "errorChangeStatus": "Erreur lors de la modification du statut de l'assesseur.",
        "orgSummary": "Organisation",
        "orgSummaryValue": "{{units}} unités · {{levels}} niveaux",
        "events": {
            "title": "Modifications dans les mandants ({{count}})",
            "intro": "Les administrateurs de mandant peuvent étendre eux-mêmes leur structure et renommer leur mandant. Vérifiez si le contrat et la facturation doivent être adaptés, puis accusez réception de l'annonce.",
            "acknowledge": "Pris connaissance",
            "loadError": "Les annonces n'ont pas pu être chargées.",
            "ackError": "L'accusé de réception a échoué."
        }
    },
    "modals": {
        "ok": "OK",
        "close": "Fermer",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "apply": "Appliquer",
        "confirmDelete": "Confirmer la suppression",
        "confirmReset": "Confirmer la réinitialisation",
        "resetScoresTitle": "Réinitialiser les scores",
        "resetScoresMessage": "Êtes-vous sûr de vouloir supprimer tous les points attribués dans cette évaluation ? Vos textes (points forts/potentiels d'amélioration) seront conservés.",
        "assessmentInfoTitle": "Méthodologie d'évaluation CAF",
        "criterionInfoTitle": "Détails du critère",
        "enablerScoringTitle": "Notation des facteurs",
        "enablerScoringIntro": "La notation est basée sur le cycle PDCA (Plan-Do-Check-Act). Évaluez le niveau de maturité de la mise en œuvre :",
        "enablerScoringDetails": {
            "plan": "<strong>PLAN (0-30 points) :</strong> Phase de planification. Il y a des approches ou des idées, mais pas encore de mise en œuvre systématique.",
            "do": "<strong>DO (31-50 points) :</strong> Mise en œuvre. Les approches sont appliquées dans les domaines pertinents.",
            "check": "<strong>CHECK (51-70 points) :</strong> Vérification. L'efficacité de la mise en œuvre est régulièrement mesurée et évaluée.",
            "act": "<strong>ACT (71-90 points) :</strong> Amélioration. Sur la base des évaluations, des actions correctives sont initiées.",
            "excellent": "<strong>EXCELLENCE (91-100 points) :</strong> L'approche sert de référence (benchmark) et est continuellement améliorée."
        },
        "resultScoringTitle": "Notation des résultats",
        "resultScoringIntro": "Ceci évalue les résultats obtenus par l'organisation. Portez une attention particulière aux tendances des 3 dernières années :",
        "resultScoringDetails": {
            "none": "<strong>0-10 points :</strong> Aucun résultat mesuré ou disponible.",
            "negative": "<strong>11-30 points :</strong> Les résultats existent mais montrent des tendances négatives ou n'atteignent pas les objectifs.",
            "stable": "<strong>31-50 points :</strong> Les résultats sont stables ou montrent de légères améliorations.",
            "positive": "<strong>51-70 points :</strong> Les résultats montrent une tendance positive claire sur plusieurs années.",
            "targets": "<strong>71-90 points :</strong> Les objectifs pertinents sont atteints ou dépassés. Comparaisons positives avec d'autres organisations.",
            "excellent": "<strong>91-100 points :</strong> Résultats remarquables dans le temps et position de tête dans les comparaisons."
        },
        "editAction": "Modifier la mesure",
        "addAction": "Ajouter une nouvelle mesure",
        "title": "Titre",
        "description": "Description",
        "relatedSubCriterion": "Critère CAF associé",
        "selectSubCriterion": "Sélectionner un critère",
        "responsiblePerson": "Personne responsable",
        "selectResponsible": "Sélectionner une personne...",
        "noResponsible": "Aucun responsable désigné",
        "dueDate": "Date d'échéance",
        "reminderDate": "Date de rappel",
        "reminderHint": "Auto : 14 jours avant la date d'échéance (min. aujourd'hui)",
        "status": "Statut",
        "deleteActionTitle": "Supprimer la mesure",
        "deleteActionMessage": "Êtes-vous sûr de vouloir supprimer cette mesure ?",
        "deleteAssessmentTitle": "Supprimer l'évaluation",
        "deleteAssessmentMessage": "Êtes-vous sûr de vouloir supprimer l'évaluation du <strong>{{date}}</strong> ?",
        "deleteCriterionTitle": "Supprimer le thème",
        "deleteCriterionMessage": "Êtes-vous sûr de vouloir supprimer le thème «<strong>{{title}}</strong>» ?",
        "deleteCriterionWarning": "Cela supprimera définitivement tous les critères associés et leurs données d'évaluation.",
        "deleteSubCriterionTitle": "Supprimer le critère",
        "deleteSubCriterionMessage": "Êtes-vous sûr de vouloir supprimer le critère «<strong>{{title}}</strong>» ?",
        "deleteSubCriterionWarning": "Cela supprimera définitivement toutes les données d'évaluation associées.",
        "deleteBestPracticeMessage": "Êtes-vous sûr de vouloir supprimer cet exemple ?",
        "editUserTitle": "Modifier l'utilisateur",
        "editProfileTitle": "Modifier le profil",
        "editUserMessage": "Modifiez les informations de l'utilisateur.",
        "createMeasure": {
            "title": "Sélection du projet",
            "forPotential": "pour le potentiel :",
            "done": "Terminé",
            "manual": "Formuler le projet manuellement",
            "aiSuggestions": "Suggestions IA",
            "generateAi": "Générer des suggestions IA",
            "analyzing": "Analyse du potentiel & du critère...",
            "relevantMethods": "Méthodes pour le critère",
            "noMethods": "Aucune méthode spécifique trouvée pour ce critère.",
            "adoptMethod": "Créer un projet",
            "methodLabel": "Méthode"
        },
        "edit": "Modifier",
        "delete": "Supprimer"
    },
    "common": {
        "serviceUnavailable": "Le service est momentanément indisponible. Veuillez réessayer plus tard.",
        "remove": "Retirer",
        "open": "Ouvrir",
        "ai": {
            "suggestionLabel": "Suggestion IA",
            "backToOverview": "Retour à la vue d'ensemble",
            "adoptSuggestion": "Créer un projet",
            "generateTitleTooltip": "Générer un titre basé sur la description"
        },
        "sessionWarning": {
            "title": "Votre session va bientôt expirer",
            "message_one": "Pour des raisons de sécurité, vous serez automatiquement déconnecté dans 1 minute. Voulez-vous rester connecté ?",
            "message_other": "Pour des raisons de sécurité, vous serez automatiquement déconnecté dans {{minutes}} minutes. Voulez-vous rester connecté ?",
            "extendButton": "Rester connecté",
            "logoutButton": "Déconnexion"
        },
        "notAvailable": "N/D",
        "assessmentSaved": "Évaluation enregistrée avec succès !",
        "actionCreated": "Action créée !",
        "actionUpdated": "Action mise à jour !",
        "noAssessmentSelected": "Aucune évaluation sélectionnée pour l'enregistrement.",
        "saving": "Enregistrement...",
        "processing": "Traitement...",
        "allChangesSaved": "Toutes les modifications enregistrées",
        "verify": "Vérifier",
        "cancel": "Annuler",
        "viewDetails": "Voir les détails",
        "description": "Description",
        "success": "Succès",
        "offlineWarningTitle": "Pas de connexion internet",
        "offlineWarningMessage": "Vous êtes actuellement hors ligne. Veuillez rétablir votre connexion internet et réessayer. Vos données ne seront pas perdues.",
        "offlineMoveTaskWarning": "Les mesures ne peuvent pas être déplacées sans connexion internet. Veuillez rétablir la connexion.",
        "errors": {
            "pdfGeneration": "Erreur lors de la génération du PDF.",
            "cleanup": "Erreur lors du nettoyage.",
            "save": "Erreur lors de l'enregistrement : {{msg}}",
            "delete": "Erreur lors de la suppression.",
            "archiveTasks": "Erreur lors de l'archivage des tâches.",
            "saveTask": "Erreur lors de l'enregistrement de la tâche.",
            "saveVote": "Erreur lors de l'enregistrement du vote : {{msg}}",
            "saveProject": "Erreur lors de l'enregistrement du projet : {{msg}}",
            "linkProject": "Erreur lors de la liaison du projet : {{msg}}",
            "pdfExport": "Erreur lors de l'exportation PDF.",
            "publish": "Erreur lors de la publication.",
            "updateStatus": "Erreur lors de la mise à jour du statut.",
            "functionsUnavailable": "Erreur : connexion aux Cloud Functions indisponible.",
            "functionsUnavailableShort": "Cloud Functions indisponible.",
            "changeRole": "Erreur : {{msg}}",
            "createLabel": "Erreur lors de la création de l'étiquette.",
            "moveTask": "Erreur lors du déplacement de la tâche.",
            "saveTaskMsg": "Erreur lors de l'enregistrement de la tâche : {{msg}}",
            "sendComment": "Erreur lors de l'envoi du commentaire",
            "backendMissing": "Erreur : connexion backend manquante.",
            "deleteUser": "Erreur lors de la suppression de l'utilisateur.",
            "deleteMsg": "Erreur lors de la suppression : {{msg}}",
            "generic": "Une erreur s'est produite"
        },
        "linkCopied": "Lien copié !",
        "sending": "Envoi...",
        "selectedCount": "{{count}} sélectionné(s)",
        "saveChanges": "Enregistrer les modifications",
        "send": "Envoyer",
        "view": "Voir",
        "unknownError": "Erreur inconnue",
        "unknownTenant": "Mandant inconnu",
        "unknownLabel": "Étiquette inconnue",
        "unknownCategory": "Catégorie inconnue",
        "unknownDate": "Inconnu",
        "ourOrganization": "Notre organisation",
        "recordedOn": "Enregistré le {{date}} par {{name}}",
        "openMenu": "Ouvrir le menu",
        "clearSearch": "Réinitialiser la recherche",
        "toggleDetails": "Afficher/masquer les détails",
        "mainContent": "Contenu principal",
        "sidebarNavigation": "Navigation latérale",
        "mainNavigation": "Navigation principale",
        "skipToContent": "Aller au contenu",
        "landmarkNavHint": "Appuyez sur F6 pour basculer entre navigation et contenu",
        "close": "Fermer",
        "save": "Enregistrer",
        "collapse": "Réduire",
        "expand": "Développer",
        "edit": "Modifier",
        "delete": "Supprimer",
        "error": "Erreur",
        "retry": "Réessayer",
        "back": "Retour",
        "moveUp": "Déplacer vers le haut",
        "moveDown": "Déplacer vers le bas",
        "errorOccurred": "Une erreur s'est produite.",
        "next": "Suivant",
        "loading": "Chargement..."
    },
    "userManagement": {
        "displayName": "Nom d'affichage",
        "title": "Gestion des utilisateurs",
        "subtitle": "Gérez les accès des utilisateurs et les assesseurs externes de votre organisation.",
        "tabs": { "internal": "Collaborateurs", "external": "Assesseurs externes" },
        "titles": { "registered": "Utilisateurs enregistrés", "associated": "Assesseurs associés" },
        "buttons": {
            "inviteUser": "Inviter un utilisateur", "addAssessor": "Ajouter un assesseur",
            "invite": "Inviter", "sending": "Envoi...", "adding": "Ajout...", "add": "Ajouter",
            "cancel": "Annuler", "edit": "Modifier", "remove": "Supprimer", "save": "Enregistrer", "saving": "Enregistrement..."
        },
        "labels": {
            "email": "Adresse e-mail", "assessorEmail": "Adresse e-mail de l'assesseur",
            "permissionLevel": "Niveau d'autorisation", "changeLevelPrefix": "Modifier",
            "changeLevelSuffix": "le niveau...", "selectLevelSuffix": "Sélectionner...", "emailLanguage": "Langue de l'invitation",
            "orgUnit": "Unité organisationnelle"
        },
        "placeholders": { "email": "collaborateur@org.com", "assessorEmail": "assesseur@externe.com", "name": "Jean Dupont", "selectOrgUnit": "Organisation principale (à l'échelle du mandant)", "chooseOrgUnit": "Choisir une unité" },
        "filters": {
            "allOrgUnits": "Toutes les unités organisationnelles",
            "filterByOrgUnit": "Filtrer par unité organisationnelle"
        },
        "badges": {
            "tenantAdmin": "Tenant-Admin",
            "mainOrg": "Organisation principale",
            "tenantWide": "À l'échelle du mandant",
            "orgAdmin": "Admin d'organisation",
            "noOrgUnit": "Aucune unité"
        },
        "hints": {
            "isOrgAdmin": "Permet à cet utilisateur d'inviter et de gérer des collègues au sein de l'unité organisationnelle sélectionnée.",
            "isOrgAdminFixed": "Vous invitez cet utilisateur en tant que membre de votre unité organisationnelle."
        },
        "table": {
            "nameEmail": "Nom / E-Mail", "orgUnit": "Unité organisationnelle", "roleStatus": "Rôle / Statut", "actions": "Actions",
            "noUsers": "Aucun utilisateur trouvé.", "noAssessors": "Aucun assesseur externe associé.",
            "caption": "Liste des utilisateurs"
        },
        "roles": { "externalAssessor": "Assesseur externe", "external": "Externe" },
        "modals": {
            "editUserTitle": "Modifier l'utilisateur", "userUpper": "UTILISATEUR", "noName": "Sans nom",
            "inviteSuccessTitle": "Utilisateur invité", "addSuccessTitle": "Ajouté avec succès",
            "emailSent": "E-mail envoyé avec succès !", "activationInfo": "L'utilisateur recevra un lien pour définir son mot de passe et activer le compte.",
            "emailFailed": "Compte créé, mais l'e-mail a échoué.",
            "emailFailedHint": "L'utilisateur a été créé dans le système, mais nous n'avons pas pu envoyer d'e-mail. Veuillez demander à l'utilisateur de cliquer sur 'Mot de passe oublié' sur la page de connexion.",
            "removeAssessorTitle": "Supprimer l'assesseur",
            "revokeAccessTitle": "Révoquer l'accès",
            "removeAssessorConfirm": "Voulez-vous supprimer l'assesseur {{email}} de ce mandant ?",
            "revokeAccessConfirm": "Voulez-vous révoquer l'accès de l'utilisateur {{email}} à cette organisation ?",
            "checkingDependencies": "Vérification des projets et tâches assignés...",
            "orphanedWarningTitle": "Attention : entrées orphelines !",
            "orphanedWarningDetail": "Cet utilisateur est encore assigné à :",
            "projectsCount": "{{count}} projet(s) en tant que chef de projet",
            "tasksCount": "{{count}} tâche(s) en tant que responsable",
            "orphanedConsequence": "La suppression de cet utilisateur laissera ces entrées sans responsabilité valide.",
            "removeAssessorNote": "L'assesseur perdra l'accès à ce mandant. Ses autres mandants ne sont pas affectés.",
            "revokeAccessNote": "Le profil sera supprimé et la connexion désactivée.",
            "userExistsDetail": "est déjà enregistré dans le système.",
            "userExistsTip": "S'il s'agit d'un assesseur, veuillez utiliser l'onglet 'Assesseurs externes'.",
            "notFoundDetail": "trouvé.",
            "assessorRegisterHint": "L'assesseur doit d'abord s'inscrire lui-même dans le système ('S'inscrire en tant qu'assesseur' sur la page de connexion) avant de pouvoir être ajouté à un mandant."
        },
        "validation": { "invalidEmail": "Adresse e-mail invalide", "nameRequired": "Le nom est obligatoire", "orgUnitRequired": "Unité organisationnelle requise" },
        "errors": {
            "permissionDenied": "Accès refusé.",
            "loadFailed": "Erreur lors du chargement des utilisateurs.",
            "inviteFailed": "Erreur lors de l'invitation",
            "addFailed": "Erreur lors de l'ajout de l'assesseur",
            "assessorInactive": "Ce compte d'assesseur est désactivé et ne peut pas être ajouté.",
            "notAnAssessor": "Cet e-mail appartient à un utilisateur existant qui N'EST PAS un assesseur.",
            "assessorAlreadyAdded": "Cet assesseur a déjà été ajouté.",
            "cannotChangeRole": "Impossible de modifier le rôle.",
            "deleteFailed": "La suppression a échoué."
        },
        "messages": {
            "assessorInvited": "Un e-mail d'invitation a été envoyé. L'assesseur peut maintenant terminer son inscription et aura ensuite accès.",
            "assessorAlreadyAdded": "Cet assesseur est déjà assigné.",
            "assessorAdded": "L'assesseur a été ajouté avec succès et peut maintenant soumettre des évaluations pour ce mandant."
        },
        "noRoles": "Aucun rôle fonctionnel"
    },
    "settings": {
        "projectSpecificTitle": "Paramètres de chaque projet",
        "projectSpecificHint": "Les membres du projet, les étiquettes et les champs spécifiques au projet pour les mesures se définissent dans chaque projet via la roue dentée en haut à droite. Cela relève du chef de projet et de la gestion de portefeuille de l'unité d'origine du projet. Les unités supérieures voient les projets transmis en lecture seule.",
        "toggleSr": "Activé/désactivé",
        "ok": "OK",
        "introUnit": "Catégories de votre unité pour le portefeuille de projets.",
        "title": "Paramètres", "intro": "Gérez les configurations globales de votre organisation.",
        "mfaTitle": "Authentification à 2 facteurs (MFA)",
        "mfaToggleLabel": "Imposer l'authentification multi-facteurs (MFA) pour tous les utilisateurs",
        "mfaDescription": "Si activé, tous les utilisateurs de cette organisation doivent configurer une app d'authentification (TOTP) avant de pouvoir continuer à utiliser CAF Suite.",
        "mfaSsoExemptNote": "Les utilisateurs SSO sont exemptés de l'obligation MFA car la vérification d'identité est gérée par le fournisseur SSO.",
        "mfaDialog": {
            "setupOwnFirst": { "title": "Protégez d'abord votre propre compte", "message": "Avant d'imposer la MFA à tous, configurez une app d'authentification pour votre propre compte. Vous ne risquez ainsi pas de vous bloquer. Activez ensuite l'obligation ici.", "confirm": "Configurer la MFA maintenant" },
            "enable": { "title": "Imposer la MFA à tous ?", "message": "Les personnes qui n'ont pas encore configuré d'app d'authentification sont immédiatement dirigées vers la configuration et ne peuvent utiliser CAF Suite qu'ensuite.", "confirm": "Imposer la MFA" },
            "disable": { "title": "Lever l'obligation MFA ?", "message": "Le second facteur devient alors facultatif. Les apps d'authentification déjà configurées restent actives.", "confirm": "Lever l'obligation" }
        },
        "analysisTitle": "Intelligence artificielle",
        "analysisToggleLabel": "Activer les fonctionnalités IA",
        "analysisDescription": "Si activé, les utilisateurs peuvent utiliser les fonctionnalités IA (ex. génération d'idées de projets ou rapports basés sur l'IA).",
        "prioritizationTitle": "Module de priorisation",
        "prioritizationToggleLabel": "Activer la priorisation des potentiels",
        "prioritizationDescription": "Active un module entre l'évaluation et le plan d'action pour présélectionner les potentiels par vote d'équipe et urgence.",
        "warningTitle": "Note importante sur la protection des données",
        "warningText": "Pour l'analyse, des données d'évaluation anonymisées, des remarques et des titres de projets sont envoyés à l'API IA. Aucune donnée personnelle n'est transmise.",
        "saveTitle": "Enregistrer les paramètres du projet", "saveSuccess": "Paramètres enregistrés.", "saveError": "Erreur lors de l'enregistrement.",
        "dataExport": {
            "title": "Export de données", "description": "Téléchargez toutes les évaluations, projets et mesures de votre organisation sous forme de fichier JSON.",
            "button": "Exporter les données", "loading": "Création de l'export...", "success": "Export téléchargé avec succès.", "error": "Erreur lors de l'exportation des données."
        },
        "promise": "Promise", "modulProjektmanagement": "Module de gestion de projet",
        "achsenImPortfoliomanagementAendern": "Modifier les axes dans la gestion de portefeuille",
        "wechseltImBubbleChartIn": "Bascule le Bubble Chart vers la vue alternative (x : alignement stratégique, y : effort estimé, taille de la bulle : bénéfice).",
        "wipLimitsAktivieren": "Activer les limites WIP",
        "wipLimitsDescription": "Contrôle le nombre de projets simultanés en phase «En cours» dans le Kanban de portefeuille à l'aide de buckets de capacité définis.",
        "kapazitaetsToepfeBucketsKonfiguration": "Configuration des buckets de capacité",
        "keineBucketsDefiniertBitteVorlage": "Aucun bucket défini. Veuillez ajuster le modèle.",
        "bucketName": "Nom du bucket", "bucketNamePlaceholder": "ex. Grands projets", "addBucket": "Ajouter un bucket",
        "projektgroessenTShirt": "Tailles de projet (T-Shirt)", "wipLimit": "Limite WIP",
        "projektrisikenAktivieren": "Activer les risques projet",
        "aktiviertDasModulProjektrisikenUm": "Active le module des risques projet pour enregistrer les risques liés aux projets avec l'étendue des dommages et la probabilité.",
        "taskManagementAktivieren": "Activer la gestion des tâches",
        "aktiviertDasModulTaskManagement": "Active le module de gestion des tâches pour gérer flexiblement les tâches par projet en listes, tableau ou chronologie.",
        "modulBewertung": "Module d'évaluation", "modulAdministration": "Module d'administration",
        "inhaltsverwaltungAktivieren": "Activer la gestion du contenu",
        "contentManagementDescription": "Active le module «Gestion du contenu» pour les administrateurs afin d'ajouter des thèmes, critères et/ou exemples personnalisés aux critères CAF officiels.",
        "availableLanguages": "Langues disponibles",
        "availableLanguagesDescription": "Définissez les langues disponibles pour les utilisateurs de ce mandant dans leur profil.",
        "loeschen": "Supprimer"},
    "app": {
        "globalTemplatesTitle": "Gérer les modèles globaux",
        "globalTemplatesIntro": "Définissez ici la structure standard (critères et bonnes pratiques) ainsi que les sections d'information pour tous les mandants.",
        "connection": {
            "connectingTitle": "Connexion en cours …",
            "connectingMessage": "La connexion est lente. Veuillez patienter un instant.",
            "failedTitle": "Échec de la connexion",
            "failedMessage": "Votre connexion au compte est valable, mais vos données n'ont pas pu être chargées, généralement en raison d'une connexion Internet lente ou interrompue. Nous réessayons automatiquement.",
            "retry": "Réessayer",
            "retrying": "Nouvelle tentative …"
        },
        "update": { "title": "Nouvelle version disponible", "description": "Une version mise à jour de la CAF Suite est prête. Veuillez enregistrer votre travail et mettre à jour l'application.", "later": "Plus tard", "now": "Mettre à jour maintenant" },
        "loading": "Chargement...", "viewNotFound": "Vue introuvable",
        "errors": {
            "noTenant": { "title": "Aucune organisation assignée", "message": "Votre compte utilisateur n'est assigné à aucune organisation. Veuillez contacter le support." },
            "accountDisabled": { "title": "Compte verrouillé / inactif", "message": "Votre compte utilisateur a été désactivé. Veuillez contacter le support ou votre administrateur.", "logout": "Se déconnecter" },
            "emailSendFailed": "Erreur d'envoi : {{msg}}", "emailSendUnknown": "Erreur d'envoi : erreur inconnue"
        },
        "navigationGuard": {
            "title": "Modifications non enregistrées", "message": "Vous avez effectué des modifications qui n'ont pas encore été enregistrées.",
            "warning": "Voulez-vous vraiment quitter la page ? Toutes les modifications non enregistrées seront perdues.", "confirmButton": "Quitter quand même"
        },
        "verifyEmail": {
            "title": "Vérification de l'e-mail requise", "prompt": "Veuillez vérifier votre adresse e-mail",
            "spamFolder": "pour continuer. Vérifiez également votre dossier spam.", "confirmReload": "J'ai confirmé (recharger la page)",
            "successMessage": "L'e-mail a été renvoyé !", "resendLink": "Renvoyer le lien de vérification"
        },
        "projectSpecificTitle": "Paramètres de chaque projet",
        "projectSpecificHint": "Les membres du projet, les étiquettes et les champs spécifiques au projet pour les mesures se définissent dans chaque projet via la roue dentée en haut à droite. Cela relève du chef de projet et de la gestion de portefeuille de l'unité d'origine du projet. Les unités supérieures voient les projets transmis en lecture seule."
    },
    "errorBoundary": {
        "title": "Une erreur s'est produite",
        "message": "L'application n'a pas pu démarrer. Cela est généralement causé par des problèmes réseau, des autorisations manquantes ou une configuration obsolète.",
        "reload": "Recharger la page"
    },
    "task": {
        "title": "Mesures (Tâches)", "open": "Ouvert", "inProgress": "En cours", "review": "Révision", "done": "Terminé",
        "labels": "Étiquettes", "effortEstimate": "Effort", "customFields": "Champs spécifiques au projet"
    },
    "projectRisks": {
        "loadError": "Erreur lors du chargement des risques du projet.",
        "matrixPosition": "Dommage : {{damage}}, probabilité : {{probability}}",
        "matrixCellTitle_one": "Dommage : {{damage}}, probabilité : {{probability}} ({{count}} risque)",
        "matrixCellTitle_other": "Dommage : {{damage}}, probabilité : {{probability}} ({{count}} risques)",
        "taskFromRiskTitle": "Mesure relative au risque : {{name}}",
        "title": "Risques projet", "description": "Gérez les risques avec l'étendue des dommages et la probabilité d'occurrence.",
        "addRisk": "Enregistrer un nouveau risque", "editRisk": "Modifier le risque", "deleteRiskTitle": "Supprimer le risque",
        "deleteRiskMessage": "Êtes-vous sûr de vouloir supprimer ce risque ?", "name": "Nom du risque",
        "riskDescription": "Description du risque (pire cas crédible)", "damage": "Étendue des dommages", "probability": "Probabilité",
        "history": "Historique", "generateTask": "Générer une mesure", "tasks": "Mesures dérivées", "matrixTitle": "Matrice des risques",
        "listTitle": "Liste des risques", "noRisks": "Aucun risque enregistré.", "save": "Enregistrer", "cancel": "Annuler", "highRisk": "Risque élevé",
        "damageOptions": { "1": "1 - Faible", "2": "2 - Notable", "3": "3 - Critique", "4": "4 - Catastrophique" },
        "probabilityOptions": { "1": "1 - Improbable", "2": "2 - Possible", "3": "3 - Probable", "4": "4 - Quasi certain" },
        "noTasksYet": "Aucune tâche liée.", "oneMeasure": "1 mesure", "measuresCount": "{{count}} mesures",
        "damage1": "1 - Faible", "damage2": "2 - Notable", "damage3": "3 - Critique", "damage4": "4 - Catastrophique",
        "prob1": "1 - Improbable", "prob2": "2 - Possible", "prob3": "3 - Probable", "prob4": "4 - Quasi certain"
    },
    "tasks": {
        "noDate": "SANS DATE",
        "today": "Aujourd'hui",
        "unnamed": "Sans titre",
        "boardReadOnly": "Lecture seule : les cartes de ce tableau ne peuvent pas être déplacées.",
        "kpiMeasures": "Mesures",
        "boardSorts": { "label": "Trier les colonnes", "manual": "Tri manuel", "alphabetical": "A-Z", "dueDate": "Date d'échéance", "taskSize": "Taille de la tâche" },
        "promise": "Promise", "reset": "Réinitialiser", "neueAufgabe": "Nouvelle tâche",
        "viewMode": { "timeline": "Chronologie" },
        "searchPlaceholder": "Rechercher par titre, description...",
        "filters": { "responsibleAll": "Responsable (Tous)", "labelAll": "Étiquette (Toutes)", "labelPrefix": "Étiquette", "dueDateAll": "Échéance (Toutes)", "dueDateNext30": "Échéance dans 30 jours", "dueDateOverdue": "En retard" },
        "status": { "TODO": "Ouvert", "IN_PROGRESS": "En cours", "REVIEW": "Révision", "DONE": "Terminé" },
        "report": {
            "taskCount_one": "{{count}} mesure",
            "taskCount_other": "{{count}} mesures",
            "title": "Rapport des mesures"
        }
    },
    "myTasks": {
        "title": "Mes tâches", "intro": "Retrouvez ici toutes les tâches qui vous sont assignées.",
        "kpi": { "open": "Tâches ouvertes", "dueSoon": "Échéance (30 j.)", "overdue": "En retard", "openSubtext": "Ni terminées ni archivées", "dueSoonSubtext": "Échéance dans les 30 prochains jours", "overdueSubtext": "Date d'échéance dépassée" },
        "list": { "taskName": "Tâche", "project": "Projet", "startDate": "Date de début", "dueDate": "Date d'échéance", "status": "Statut" },
        "filters": { "search": "Rechercher...", "project": "Projet", "status": "Statut", "reset": "Réinitialiser", "projectAll": "Projet (Tous)" },
        "noTasks": "Vous n'avez actuellement aucune tâche assignée."
    },
    "portfolio": {
        "keineProjektleitung": "Aucun chef de projet",
        "loadError": "Erreur lors du chargement des projets.",
        "wipLimitWarning": "Attention : la limite de capacité configurée pour cette taille de projet est déjà atteinte. Mettre davantage de projets en œuvre entraîne généralement des goulets d'étranglement et des retards pour les projets en cours.",
        "wipLimitQuestion": "Souhaitez-vous tout de même mettre ce projet en œuvre en raison de priorités urgentes ou d'une escalade ?",
        "filterClear": "Effacer le filtre",
        "healthAtRisk": "Pouls critique",
        "healthOnTrack": "En bonne voie",
        "title": "Portefeuille de projets", "searchPlaceholder": "Rechercher par titre, description, chef de projet...",
        "intro": "Gérez vos projets de mise en œuvre stratégique.", "newProject": "Nouveau projet",
        "noProjects": "Aucun projet disponible. Commencez à mettre en œuvre vos objectifs CAF.",
        "ungueltigeVerantwortlichkeitTitle": "Responsabilité invalide", "statusLabel": "Statut :",
        "status": { "IDEA": "Idée", "EVALUATING": "En évaluation", "IN_PROGRESS": "En cours", "ON_HOLD": "En attente", "COMPLETED": "Terminé", "ARCHIVED": "Archivé" },
        "kpi": { "total": "Tous les projets", "active": "Actifs", "completed": "Terminés", "atRisk": "Pouls critique", "decisionNeeded": "Décisions" },
        "filters": { "originUnitGroup": "Unité d'origine", "ownCategories": "Catégories propres", "topicCategories": "Thèmes transversaux", "all": "Tous (sauf archivés)", "active": "Actifs seulement", "decision": "Décisions", "missingRatings": "Évaluations manquantes", "category": "Catégorie", "save": "Enregistrer le filtre", "saveTooltip": "Enregistrer la sélection de filtre actuelle", "saved": "Enregistré", "categoryAll": "Catégorie (Toutes)", "allOrgUnits": "Unité organisationnelle (Toutes)", "relationAll": "Origine (Toutes)", "relationOwn": "Propre unité", "relationPromoted": "Transmis", "relationTopic": "Thème transversal"},
        "itPortfolioFilter": "Projets informatiques uniquement",
        "boardSorts": { "label": "Tri", "manual": "Manuel", "alphabetical": "Alphabétique", "dueDate": "Date cible", "projectSize": "Taille du projet" },
        "matrixWarning": "Certains projets ne sont pas affichés dans la matrice car il manque l'estimation de l'effort, l'importance stratégique ou le bénéfice.",
        "unratedProjectsWarning": "Les projets suivants n'ont pas encore été évalués et ne peuvent donc pas être affichés dans le graphique.",
        "showMissing": "Voir dans la vue liste",
        "viewMode": { "list": "Liste", "matrix": "Matrice", "kanban": "Kanban", "roadmap": "Feuille de route" },
        "export": {
            "page": "Page",
            "projectOverviewTitle": "Aperçu du projet",
            "tableHeaderProject": "Projet",
            "tableHeaderPulseCheck": "Pulse Check",
            "chartRenderError": "Le graphique n'a pas pu être rendu.",
            "noCafReference": "Aucune référence CAF",
            "trafficLightsTitle": "Feux tricolores :",
            "button": "Exporter la vue actuelle", "title": "Exporter le portefeuille en PDF", "subtitle": "L'export adopte la vue, les filtres et le tri actuels.",
            "includeDetails": "Inclure les détails du projet", "includeStatus": "Inclure le statut du projet (feux tricolores, synthèse, décisions)",
            "groupBy": "Regrouper les détails du projet par", "groupByNone": "Sans regroupement", "groupByStatus": "Statut", "groupByResponsible": "Responsabilité", "groupByCafCriterion": "Critère CAF",
            "generating": "Génération...", "create": "Créer un PDF", "cancel": "Annuler",
            "reportTitle": "Rapport du portefeuille de projets",
            "organization": "Organisation :",
            "viewModeLabel": "Vue :",
            "filterActive": "Filtre actif",
            "createdOn": "Créé le :",
            "unnamedProject": "Projet sans nom",
            "noDate": "SANS DATE",
            "today": "Aujourd'hui",
            "noData": "Sans données :",
            "benefitAxis": "Bénéfice (Bas \u2192 Haut)",
            "strategyAxis": "Alignement stratégique (Bas \u2192 Haut)",
            "capacityLimit": "UTILISATION DES CAPACITÉS",
            "unnamedBucket": "Sans nom",
            "projectCount": "Projets"
        },
        "strategiebezug": "Alignement stratégique :", "aufwand": "Effort :", "nutzen": "Bénéfice :", "gesetzlicherAuftrag": "Mandat légal",
        "chartXAxis": "Alignement stratégique (Bas ➔ Haut)",
        "chartYAxisBenefit": "Bénéfice (Bas ➔ Haut)",
        "chartYAxisEffort": "Effort (Bas ➔ Haut)",
        "chartBubbleSize": "Taille bulle",
        "chartBubbleScaledBenefit": "Bénéfice projet mis à l'échelle (1-10)",
        "chartBubbleEstimatedEffort": "Effort estimé (S-XL)",
        "board": "Tableau", "reset": "Réinitialiser", "zeit": "Délai", "budget": "Budget", "team": "Équipe", "qualitaet": "Qualité",
        "kapazitaetsauslastung": "Utilisation des capacités", "keineProjekteZurDarstellungGefunden": "Aucun projet trouvé à afficher.",
        "normalesProjekt": "Projet normal", "wipLimitUeberschritten": "Limite WIP dépassée", "abbrechen": "Annuler",
        "trotzdemFortfahren": "Continuer quand même", "keineAngabe": "N/D", "keinStatus": "Aucun statut",
        "aufKurs": "En bonne voie", "ungewiss": "Incertain", "kritisch": "Critique",
        "cafBezugAlle": "Référence CAF (Toutes)", "projektleitungAlle": "Chef de projet (Tous)", "project": "Projet",
        "projectList": "Liste des projets",
        "moveLock": {
            "foreign": "Le projet ne peut pas être déplacé, car il est géré par {{unit}}.",
            "noRight": "Seule la gestion du portefeuille ou la personne responsable peut déplacer ce projet."
        },
        "relation": {
            "promotedFrom": "Transmis par {{unit}}",
            "topic": "Thème {{topics}} · {{unit}}",
            "personal": "Participation · {{unit}}"
        }
    },
    "project": {
        "labels": "Étiquettes",
        "noAccess": "Vous n'avez pas accès à ce projet.",
        "loadError": "Erreur lors du chargement du projet.",
        "details": "Détails du projet", "title": "Nom du projet", "description": "Objectifs & Description", "initialSituation": "Situation initiale",
        "managementSummary": "Synthèse", "sponsor": "Client / Commanditaire", "steeringCommittee": "Comité de pilotage", "measurableSuccess": "Succès mesurable",
        "cafReference": "Référence CAF", "category": "Catégorie", "responsible": "Chef de projet",
        "startDate": "Date de début", "dueDate": "Date cible", "effortEstimate": "Effort estimé",
        "notEstimated": "Non estimé",
        "strategicImportance": "Importance stratégique", "benefit": "Bénéfice (interne / externe)", "isLegalRequirement": "Mandat légal",
        "status": "Statut", "decisionNeeded": "Escalade / Décision requise",
        "decisionNeededPlaceholder": "Que doit décider le comité de pilotage / la direction pour que le projet avance ?",
        "addEscalation": "Ajouter un besoin de décision", "saveEscalation": "Ajouter", "noEscalations": "Aucune décision requise actuellement.",
        "activeEscalations": "Décisions requises", "resolveEscalationBtn": "Documenter la décision",
        "recordDecisionTitle": "Documenter la décision", "recordDecisionIntro": "Enregistrez ce qui a été décidé concernant l'escalade actuelle. Cette décision sera déplacée en historique après enregistrement.",
        "decision": "Décision prise", "logDecisionBtn": "Enregistrer la décision", "decisionHistory": "Historique des décisions",
        "trafficLights": { "title": "Pulse Check (Feux tricolores)", "time": "Délai / Planning", "budget": "Coûts / Budget", "resources": "Ressources / Équipe", "quality": "Qualité / Périmètre" },
        "deleteTitle": "Supprimer le projet ?", "deleteMessage": "Êtes-vous sûr de vouloir supprimer définitivement ce projet y compris toutes les tâches ?",
        "archiveWarningTitle": "Archiver le projet ?", "archiveWarningMessage": "Si vous définissez le statut sur «Archivé», toutes les mesures (tâches) de ce projet seront également archivées. Continuer ?",
        "archiveWarningConfirm": "Oui, archiver",
        "export": { 
            "button": "Exporter la vue actuelle", 
            "title": "Exporter le projet en PDF", 
            "subtitle": "Sélectionnez les sections souhaitées pour l'export.", 
            "optionDetails": "Détails du projet", 
            "optionPulseCheck": "Pulse Check", 
            "optionPulseCheckSummary": "Pulse Check (incl. synthèse)",
            "optionTaskOverview": "Vue d'ensemble des mesures", 
            "optionTaskDetails": "Détails des mesures", 
            "optionRisks": "Risques du projet",
            "optionDecisions": "Décisions requises",
            "decisionNone": "Aucune",
            "decisionOpen": "Uniquement les décisions ouvertes",
            "decisionAll": "Toutes les décisions (incl. l'historique)",
            "detailsTitle": "Exporter les détails du projet",
            "tasksTitle": "Exporter les mesures",
            "cancel": "Annuler", 
            "create": "Créer un PDF", 
            "generating": "Génération..." 
        },
        "report": {
            "title": "Rapport de projet",
            "decisionHistoryTitle": "Décisions requises & Historique",
            "decisionOpenTitle": "Décisions ouvertes (Escalades) :",
            "decisionNone": "Actuellement aucune décision ouverte.",
            "decisionHistorySubtitle": "Historique des décisions (déjà prises) :",
            "decisionHistoryNone": "Aucun historique disponible.",
            "decisionDate": "Décidé le",
            "decisionQuestion": "Question :",
            "decisionAnswer": "Décision :",
            "riskTitle": "Risques du projet",
            "riskMatrixTitle": "Matrice des risques",
            "riskListTitle": "Liste des risques",
            "riskProb": "Probabilité (1 - 4)",
            "riskDamage": "Ampleur des dommages (1 - 4)",
            "riskNo": "N°",
            "riskName": "Nom du risque",
            "riskTableDamage": "Dommage",
            "riskTableProb": "Prob.",
            "riskDesc": "Description"
        },
        "newProject": "Nouveau projet",
        "notFound": "Projet introuvable"
    },
    "backend": {
        "errors": {
            "ungueltigeEingabe": "Saisie invalide.",
            "unerwarteterFehler": "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
            "nurTenantAdmins": "Cette action est réservée aux administrateurs du mandant.",
            "keineBerechtigungFuerEinheit": "Pas d'autorisation pour cette unité organisationnelle.",
            "organisationseinheitNichtGefunden": "Unité organisationnelle introuvable.",
            "organisationseinheitFehlt": "L'unité organisationnelle est manquante.",
            "organisationseinheitFehltOderDeaktiviert": "L'unité organisationnelle n'existe pas ou est désactivée.",
            "keineOrganisationseinheitZugeordnet": "Aucune unité organisationnelle ne vous est attribuée.",
            "uebergeordneteEinheitNichtGefunden": "L'unité supérieure est introuvable.",
            "uebergeordneteEinheitFehltOderDeaktiviert": "L'unité supérieure n'existe pas ou est désactivée.",
            "nameDerEinheitFehlt": "Le nom de l'unité organisationnelle est obligatoire.",
            "obersteEinheitNichtVerschiebbar": "L'unité de plus haut niveau ne peut pas être déplacée.",
            "einheitNichtSichSelbstUnterstellt": "Une unité ne peut pas être rattachée à elle-même.",
            "verschiebenUnterDeaktivierteEinheit": "Les unités ne peuvent pas être déplacées sous une unité désactivée.",
            "zirkulaereHierarchie": "La nouvelle unité supérieure se trouve sous l'unité déplacée. Cela créerait une hiérarchie circulaire.",
            "zuVieleEbenenNachVerschiebung": "Après le déplacement, la structure compterait plus de niveaux qu'autorisé.",
            "anlegenUnterDeaktivierterEinheit": "Il n'est pas possible de créer des unités sous une unité désactivée.",
            "hoechsteEbeneErreicht": "La structure organisationnelle compte déjà le nombre maximal de niveaux.",
            "einfuegenHoechsteEbeneErreicht": "La structure compte déjà le nombre maximal de niveaux ; aucune unité ne peut être insérée au-dessus.",
            "mandantHatBereitsObersteEinheit": "Le mandant possède déjà une unité de plus haut niveau.",
            "obersteEinheitNichtDeaktivierbar": "L'unité de plus haut niveau ne peut pas être désactivée.",
            "zuerstUntereinheitenDeaktivieren": "Veuillez d'abord désactiver toutes les unités subordonnées.",
            "verschiebenBestaetigen": "Le déplacement annule des partages ou des transmissions. Veuillez en confirmer les conséquences.",
            "keineEindeutigeObersteEinheit": "La structure organisationnelle n'a pas d'unité de plus haut niveau unique. Veuillez contacter le support.",
            "obersteEinheitGenauEineUntereinheit": "L'unité de plus haut niveau ne peut être retirée que si elle a exactement une sous-unité.",
            "verbleibendeEinheitDeaktiviert": "L'unité restante est désactivée et ne peut pas devenir l'unité de plus haut niveau.",
            "obersteEinheitHatPersonen": "Des personnes sont rattachées à l'unité de plus haut niveau. Elle ne peut plus être retirée.",
            "obersteEinheitHatAssessments": "L'unité de plus haut niveau possède des évaluations. Elle ne peut plus être retirée.",
            "obersteEinheitHatFreigaben": "Des évaluations ont déjà été partagées avec l'unité de plus haut niveau. Elle ne peut plus être retirée.",
            "obersteEinheitHatProjekte": "L'unité de plus haut niveau possède des projets. Elle ne peut plus être retirée.",
            "obersteEinheitHatWeitergaben": "Des projets ont déjà été transmis à l'unité de plus haut niveau. Elle ne peut plus être retirée.",
            "obersteEinheitHatQuerschnittsthema": "L'unité de plus haut niveau est responsable d'un thème transversal. Elle ne peut plus être retirée.",
            "obersteEinheitNichtLoeschbar": "L'unité de plus haut niveau ne peut pas être supprimée.",
            "einheitHatUntereinheiten": "Cette unité organisationnelle a encore des unités subordonnées.",
            "einheitHatPersonen": "Des personnes sont encore rattachées à cette unité organisationnelle.",
            "einheitHatAssessments": "Cette unité organisationnelle possède des évaluations. Veuillez la désactiver au lieu de la supprimer.",
            "einheitHatProjekte": "Cette unité organisationnelle possède des projets. Veuillez la désactiver au lieu de la supprimer.",
            "einheitHatQuerschnittsthema": "Cette unité organisationnelle est responsable d'un thème transversal.",
            "projekteAnlegenNurPortfolioUndProjektleitung": "Seuls la gestion de portefeuille et les chefs de projet peuvent créer des projets.",
            "querschnittsthemenNurPortfoliomanagement": "Les thèmes transversaux sont attribués par la gestion de portefeuille de l'unité d'origine.",
            "weitergebenNurPortfoliomanagement": "Seule la gestion de portefeuille de l'unité où se trouve actuellement le projet peut le transmettre.",
            "obersteEinheitKannNichtWeitergeben": "L'unité de plus haut niveau ne peut pas transmettre de projets.",
            "zurueckziehenNurPortfoliomanagement": "Seule la gestion de portefeuille peut retirer une transmission.",
            "projektNichtVonIhrerEinheitWeitergegeben": "Votre unité n'a pas transmis ce projet.",
            "unbekanntesQuerschnittsthema": "Thème transversal inconnu ou désactivé.",
            "querschnittsthemaDeaktiviert": "Le thème transversal est désactivé.",
            "sichtDerEinheitNurPortfoliomanagement": "La vue de l'unité est gérée par la gestion de portefeuille.",
            "projektFuerEinheitNichtFreigegeben": "Le projet n'est pas partagé avec votre unité.",
            "unbekannteKategorie": "Catégorie inconnue.",
            "unbekannterPortfoliostatus": "Statut de portefeuille inconnu.",
            "notizLeer": "La note est vide.",
            "notizNichtGefunden": "Note introuvable.",
            "nurEigeneNotizenLoeschen": "Vous ne pouvez supprimer que vos propres notes.",
            "projekteLoeschenNurPortfoliomanagement": "Les projets sont supprimés par la gestion de portefeuille de l'unité d'origine.",
            "ungueltigeProjektdaten": "Les données du projet sont invalides. Veuillez vérifier vos saisies.",
            "titelFehlt": "Le titre est manquant.",
            "assessmentNichtGefunden": "Évaluation introuvable.",
            "keineBerechtigungFuerAssessmentsDerEinheit": "Pas d'autorisation pour les évaluations de cette unité organisationnelle.",
            "assessmentAbgeschlossen": "L'évaluation est clôturée. Veuillez d'abord la rouvrir.",
            "aktionImStatusNichtMoeglich": "Cette action n'est pas possible dans le statut actuel.",
            "assessmentsAnlegenNurQmManagement": "Les évaluations sont créées par le QM-Management.",
            "obersteEinheitOhneUebergeordnete": "L'unité de plus haut niveau n'a pas d'unité supérieure.",
            "bewertungBereitsEingereicht": "Cette évaluation a déjà été soumise.",
            "aggregatNurQmUndManagement": "Seuls le QM-Management et le Management de l'unité elle-même voient l'agrégat.",
            "vergleichswerteNurQmUndManagement": "Seuls le QM-Management et le Management voient les valeurs de comparaison.",
            "ungueltigeFarbe": "Couleur invalide.",
            "zustaendigeEinheitFehlt": "L'unité responsable est manquante.",
            "nameFehlt": "Le nom est manquant.",
            "nameZuLang": "Le nom est trop long.",
            "querschnittsthemaNichtGefunden": "Thème transversal introuvable.",
            "kategorienNurPortfoliomanagement": "Les catégories sont gérées par la gestion de portefeuille de l'unité.",
            "kategorieNichtGefunden": "Catégorie introuvable.",
            "mindestensEinStatus": "Au moins un statut est requis.",
            "statusIdsNichtEindeutig": "Les identifiants de statut ne sont pas uniques.",
            "statusNamenDoppelt": "Deux statuts portent le même nom.",
            "startNachFaelligkeit": "La date de début ne doit pas être postérieure à la date d'échéance.",
            "erinnerungNachFaelligkeit": "La date de rappel ne doit pas être postérieure à la date d'échéance.",
            "statusFehlt": "Le statut est manquant.",
            "kommentarLeer": "Le commentaire ne peut pas être vide.",
            "farbeFehlt": "La couleur est manquante.",
            "risikonameFehlt": "Le nom du risque est manquant.",
            "keineBerechtigungBenutzerLoeschen": "Pas d'autorisation pour supprimer des utilisateurs.",
            "superAdminsNichtLoeschbar": "Les Super Admins ne peuvent pas être supprimés.",
            "orgAdminsNurEigeneEinheitEntfernen": "Les admins d'organisation ne peuvent retirer que des utilisateurs de leur propre unité organisationnelle.",
            "orgAdminsKeineTenantAdminsLoeschen": "Les admins d'organisation ne peuvent pas supprimer d'administrateurs du mandant.",
            "spracheNichtVerfuegbar": "Cette langue n'est pas activée pour votre mandant.",
            "keineBerechtigungRollenBearbeiten": "Pas d'autorisation pour modifier des rôles.",
            "superAdminsUndAssessorenNichtHier": "Les Super Admins et les assesseurs ne sont pas gérés ici.",
            "orgAdminsNurEigeneEinheitRollen": "Les admins d'organisation ne peuvent modifier que les rôles de leur propre unité organisationnelle.",
            "orgAdminsKeineTenantAdminsErnennen": "Les admins d'organisation ne peuvent pas nommer d'administrateurs du mandant.",
            "benutzerNichtImMandanten": "L'utilisateur n'appartient pas à ce mandant.",
            "totpAktivierenFehlgeschlagen": "La connexion avec une application d'authentification (TOTP) n'a pas pu être activée.",
            "konfigurationSpeichernFehlgeschlagen": "La configuration n'a pas pu être enregistrée.",
            "datenexportFehlgeschlagen": "L'exportation des données a échoué.",
            "loeschungFehlgeschlagen": "La suppression a échoué.",
            "einladenNurAdmins": "Seuls les administrateurs du mandant et les admins d'organisation peuvent inviter des utilisateurs.",
            "orgAdminsNurEigeneEinheitEinladen": "Les admins d'organisation ne peuvent inviter des utilisateurs que dans leur propre unité organisationnelle.",
            "assessorenEinladenNurAdmins": "Seuls les administrateurs du mandant et les admins d'organisation peuvent inviter des assesseurs externes.",
            "assessorHinzufuegenFehlgeschlagen": "L'assesseur n'a pas pu être ajouté.",
            "keineBerechtigungAssessorenEntfernen": "Pas d'autorisation pour retirer des assesseurs.",
            "assessorNichtGefunden": "Assesseur introuvable.",
            "orgAdminsNurEigeneAssessorenEntfernen": "Les admins d'organisation ne peuvent retirer que des assesseurs de leur propre unité organisationnelle.",
            "orgAdminsKeineMandantenweitenAssessoren": "Les admins d'organisation ne peuvent pas retirer d'assesseurs valables pour tout le mandant.",
            "ungueltigeEmail": "Adresse e-mail invalide.",
            "einladungNichtGefunden": "L'invitation est introuvable. Veuillez vérifier le lien.",
            "einladungBereitsVerwendet": "Cette invitation a déjà été utilisée.",
            "einladungAbgelaufen": "L'invitation a expiré. Veuillez en demander une nouvelle.",
            "anzeigenameFehlt": "Le nom d'affichage est manquant.",
            "idpEntityIdFehlt": "L'IdP Entity ID est manquant.",
            "ssoUrlUngueltig": "L'URL SSO doit être une URL valide.",
            "zertifikatFehlt": "Le certificat est trop court ou manquant.",
            "ssoDomainFehlt": "Au moins un domaine SSO est requis.",
            "clientIdFehlt": "Le Client ID est manquant.",
            "issuerUrlUngueltig": "L'URL de l'émetteur (issuer) doit être une URL valide.",
            "ssoKonfigurationFehlgeschlagen": "Erreur lors de la configuration SSO.",
            "ssoEntfernenFehlgeschlagen": "Erreur lors de la suppression de la configuration SSO.",
            "oidcKonfigurationFehlgeschlagen": "Erreur lors de la configuration OIDC.",
            "keineSsoKonfigurationFuerDomain": "Aucun SSO n'est configuré pour le domaine de votre adresse e-mail.",
            "benutzerErstellungFehlgeschlagen": "Le compte utilisateur n'a pas pu être créé.",
            "sicherheitspruefungFehlgeschlagen": "La vérification de sécurité a échoué. Veuillez recharger la page.",
            "cafStructureSaveFailed": "Erreur lors de l'enregistrement de la structure. Disposez-vous des autorisations nécessaires ?",
            "authErforderlich": "Authentification requise",
            "falscherMandant": "Mauvais mandant.",
            "fehlerBeimLoeschenDesAuthaccounts": "Erreur lors de la suppression du compte Auth. Opération annulée pour éviter une incohérence des données.",
            "benutzerNichtGefunden": "Utilisateur non trouvé.",
            "zugriffVerweigertFremderMandant": "Accès refusé (mandant étranger).",
            "superAdminsKoennenNichtGeaendert": "Les Super Admins ne peuvent pas être modifiés.",
            "sieHabenKeineBerechtigungDie": "Vous n'avez pas l'autorisation d'attribuer le rôle «Super Admin».",
            "authentifizierungErforderlich": "Authentification requise",
            "fehlendeDatenName": "Données manquantes : Nom.",
            "benutzerExistiertBereits": "L'utilisateur existe déjà.",
            "keinMandantZugeordnet": "Aucun mandant assigné.",
            "bewertungKonnteNichtGeladenWerden": "L'évaluation n'a pas pu être chargée.",
            "nurAdministratorenDuerfenAssessmentsLoeschen": "Seuls les administrateurs peuvent supprimer les évaluations.",
            "youAreNotAuthorizedFor": "Vous n'êtes pas autorisé pour ce mandant.",
            "youHaveBeenRemovedFrom": "Vous avez été retiré de ce mandant.",
            "keineBerechtigungZumAbstimmen": "Pas d'autorisation pour voter.",
            "nurSuperAdminsDuerfenDiese": "Seuls les Super Admins peuvent effectuer cette action.",
            "zieluserIstKeinAssessor": "L'utilisateur cible n'est pas un assesseur.",
            "sieHabenKeineBerechtigungSuper": "Vous n'avez pas l'autorisation d'inviter des Super Admins.",
            "ungueltigeRolle": "Rôle invalide.",
            "benutzerExistiertBereitsImSystem": "L'utilisateur existe déjà dans le système.",
            "keinMandantTenantIdGefunden": "Aucun mandant (Tenant ID) trouvé.",
            "benutzerExistiertBereitsIstAber": "L'utilisateur existe déjà mais n'est pas un assesseur",
            "mismatchTenantId": "Non-concordance du Tenant ID",
            "ungueltigerLink": "Lien invalide.",
            "falscherLinktyp": "Type de lien incorrect.",
            "linkAbgelaufen": "Lien expiré.",
            "kontoNichtGefunden": "Compte non trouvé.",
            "fehlerBeimPruefenDerEinladung": "Erreur lors de la vérification de l'invitation.",
            "tokenUngueltig": "Token invalide.",
            "bereitsVerwendet": "Déjà utilisé.",
            "abgelaufen": "Expiré.",
            "ungueltigerInhaltNachBereinigungLeer": "Contenu invalide (vide après nettoyage).",
            "zuVieleAnfragenBitteVersuchen": "Trop de requêtes. Veuillez réessayer ultérieurement.",
            "fehlerBeimSendenDerNachricht": "Erreur lors de l'envoi du message.",
            "keineEmailImTokenGefunden": "Aucun e-mail trouvé dans le token.",
            "unzureichendeBerechtigungLevel20Erforderlich": "Autorisation insuffisante : niveau 20 requis.",
            "projektNichtGefunden": "Projet non trouvé.",
            "level20DarfNurZugewiesene": "Le niveau 20 ne peut modifier que les projets assignés.",
            "risikoNichtGefunden": "Risque non trouvé.",
            "level20ErforderlichUmRisiken": "Niveau 20+ requis pour supprimer des risques.",
            "level20DarfNurEigene": "Le niveau 20 ne peut modifier que ses propres projets (dont il est responsable).",
            "unzureichendeBerechtigungUmProjektmitgliederZu": "Autorisation insuffisante pour gérer les membres du projet.",
            "mandantNichtGefunden": "Mandant non trouvé.",
            "fehlerBeiDerDomainpruefung": "Erreur lors de la vérification du domaine.",
            "keineEmailadresseImAuthtoken": "Aucune adresse e-mail dans le token Auth.",
            "ungueltigeEmaildomain": "Domaine e-mail invalide.",
            "zugriffVerweigertSieSindKein": "Accès refusé : vous n'êtes pas membre de ce projet.",
            "kommentarNichtGefunden": "Commentaire non trouvé.",
            "sieDuerfenNurEigeneKommentare": "Vous ne pouvez supprimer que vos propres commentaires.",
            "konfigurationsfehlerAiServiceNichtVerfuegbar": "Erreur de configuration : service IA non disponible.",
            "benutzerIstNichtEingeloggt": "L'utilisateur n'est pas connecté.",
            "benutzerprofilNichtGefunden": "Profil utilisateur non trouvé.",
            "multifaktorauthentifizierungMfaIstFuerDiesen": "L'authentification multi-facteurs (MFA) est requise pour ce mandant.",
            "mfaZuerstSelbstEinrichten": "Configurez d'abord un second facteur pour votre propre compte. Vous pourrez ensuite imposer la MFA à tous.",
            "keineBerechtigung": "Pas d'autorisation.",
            "projektleitungAendertPortfoliomanagement": "Le chef de projet est désigné par la gestion de portefeuille de l'unité d'origine.",
            "kiFuerMandantAusgeschaltet": "Les fonctions d'IA sont désactivées pour ce mandant.",
            "kiAbrechnung": "L'IA n'est pas disponible en raison d'un problème de facturation. Veuillez informer le support.",
            "kiModellNichtVerfuegbar": "Le modèle d'IA n'est pas disponible pour le moment. Veuillez informer le support.",
            "kiAusgelastet": "L'IA est très sollicitée pour le moment. Veuillez réessayer dans quelques minutes.",
            "kiNichtErreichbar": "L'IA n'est pas accessible pour le moment. Veuillez réessayer plus tard.",
            "kiKeineAntwort": "L'IA n'a pas fourni de réponse exploitable. Veuillez réessayer.",
            "kiTageslimitErreicht": "La limite journalière des fonctions d'IA est atteinte. Veuillez réessayer demain.",
            "kiTextZuLang": "Le texte est trop long pour l'IA. Veuillez le raccourcir.",
            "fehlerBeiDerBerechtigungspruefung": "Erreur lors de la vérification des autorisations.",
            "tenantidFehltFuerDieBerechtigungspruefung": "tenantId manquant pour la vérification des autorisations.",
            "zugriffAufDiesenMandantenVerweigert": "Accès à ce mandant refusé.",
            "mandantGesperrt": "Le mandant est bloqué. L'accès n'est pas possible.",
            "mandantGesperrtKeineZugaenge": "Le mandant est bloqué. Il n'est pas possible d'ajouter des personnes ni des assesseurs.",
            "mandantGesperrtKeineEinreichung": "Le mandant est bloqué et n'accepte aucune évaluation.",
            "adminSaveFailed": "Erreur lors de l'enregistrement. Il s'agit souvent d'un problème d'autorisations."
        }
    },
    "aisettings": { "promise": "Promise" },
    "riskHistory": {
        "taskCreated": "Mesure créée",
        "damageChanged": "Étendue des dommages : {{from}} → {{to}}",
        "probabilityChanged": "Probabilité : {{from}} → {{to}}",
        "nameChanged": "Titre modifié", "descriptionChanged": "Description modifiée",
        "noChanges": "Aucune modification pertinente", "created": "Créé"
    },
    "contentmanagement": {
        "globaleVorlagen": "Modèles globaux",
        "meineOrganisation": "Mon organisation",
        "typ": "Type",
        "gesperrt": "Verrouillé",
        "zentralVerwaltetHinweis": "Remarque : ces contenus sont gérés de manière centralisée et ne peuvent être modifiés que par les administrateurs système.",
        "verfuegbareMethoden": "Méthodes disponibles ({{count}})",
        "id": "ID",
        "abschnittLoeschen": "Supprimer la section",
        "beispielEntfernen": "Retirer l'exemple",
        "methodenList": "Liste des méthodes",
        "modulLoeschen": "Supprimer le module",
        "methodeLoeschen": "Supprimer la méthode",
        "beispielLoeschen": "Supprimer l'exemple",
        "themenfeldLoeschenFrage": "Voulez-vous vraiment supprimer le thème «<strong>{{title}}</strong>» et tous les critères qu'il contient ?",
        "kriteriumLoeschenFrage": "Voulez-vous vraiment supprimer le critère «<strong>{{title}}</strong>» ?",
        "modulLoeschenFrage": "Voulez-vous vraiment supprimer le module d'information «<strong>{{title}}</strong>» ?",
        "abschnittLoeschenFrage": "Voulez-vous vraiment supprimer la section «<strong>{{title}}</strong>» ?",
        "methodeEntfernenFrage": "Voulez-vous vraiment retirer la méthode «<strong>{{title}}</strong>» de la boîte à méthodes ?",
        "beispielEntfernenFrage": "Voulez-vous vraiment retirer l'exemple «<strong>{{title}}</strong>» ?",
        "ok": "OK",
        "promise": "Promise", "inhalteExportieren": "Exporter le contenu",
        "cafThemenfelderKriterien": "Thèmes & Critères CAF", "informationsbereiche": "Sections d'information",
        "methodenbaukasten": "Boîte à méthodes", "standardIndividualisierung": "Standard & Personnalisation",
        "inhalteMitEinemSchlossSymbol": "Contenus avec un symbole de cadenas (",
        "standardContentInfo": "Les contenus marqués d'un cadenas font partie du standard CAF global et ne peuvent pas être modifiés. Vous pouvez cependant ajouter vos propres thèmes, critères et exemples.",
        "beschreibung": "Description", "detailbeschreibung": "Description détaillée", "beispiele": "Exemples",
        "beispielHinzufuegen": "Ajouter un exemple", "kriteriumHinzufuegen": "Ajouter un critère",
        "neuesThemenfeldHinzufuegen": "Ajouter un nouveau thème",
        "ueberInformationsmodule": "À propos des modules d'information",
        "dieseModuleWerdenImLern": "Ces modules sont affichés dans le Centre d'apprentissage au-dessus des thèmes. Ils fournissent des informations générales sur le CAF.",
        "modulTitel": "Titre du module", "einleitungBeschreibung": "Introduction / Description",
        "abschnittHinzufuegen": "Ajouter une section", "neuesInformationsmodulHinzufuegen": "Ajouter un nouveau module d'information",
        "zentraleSammlungVonMethodenDie": "Collection centrale de méthodes liées aux critères CAF. Visibles par tous les mandants.",
        "methodeHinzufuegen": "Ajouter une méthode", "titel": "Titre", "zielZweck": "Objectif / But",
        "aktionen": "Actions", "keineMethodenVorhanden": "Aucune méthode disponible.", "achtung": "ATTENTION :",
        "diesEntferntAlleIhreIndividuellen": "Cela supprime toutes vos personnalisations. Seul le contenu standard du modèle CAF sera conservé. Cette action est irréversible.",
        "themenfeldLoeschen": "Supprimer le thème", "kriteriumLoeschen": "Supprimer le critère",
        "methodenDurchsuchen": "Rechercher des méthodes...", "themenfeldWaehlen": "Choisir un thème...",
        "kriteriumWaehlen": "Choisir un critère...", "bearbeiten": "Modifier", "loeschen": "Supprimer",
        "themenfeld": "Thème", "kriterium": "Critère", "beispiel": "Exemple", "abschnitt": "Section", "inhalt": "Contenu"
    },
    "mfasetup": {
        "qrCodeAlt": "Code QR pour l'application d'authentification",
        "seiteNeuLadenWennBestaetigt": "Recharger la page (une fois confirmé)",
        "oeffnenSieIhreAuthenticatorApp": "Ouvrez votre application d'authentification (Google Authenticator, Microsoft Authenticator, etc.) et scannez ce code.",
        "gebenSieDen6Stelligen": "Saisissez le code à 6 chiffres",
        "ihrKontoIstNunZusaetzlich": "Votre compte est maintenant protégé. Vous allez être redirigé.",
        "zumDashboard": "Vers le tableau de bord"
    },
    "mytasks": { "keineAufgabenEntsprechenDenGewaehlten": "Aucune tâche ne correspond aux filtres sélectionnés." },
    "projectdetail": {
        "projektbewertungPriorisierung": "Évaluation & Priorisation du projet",
        "ungueltigeVerantwortlichkeit": "Responsabilité invalide",
        "dieAktuellZugewiesenePersonIst": "La personne actuellement assignée n'est plus utilisateur de ce mandant. Veuillez assigner un nouveau chef de projet.",
        "statusSchnelleinschaetzung": "Statut Pulse Check", "entschieden": "DÉCIDÉ",
        "urspruenglichesProblem": "Question initiale :", "projektEinstellungen": "Paramètres du projet", "exportieren": "Exporter les détails du projet",
        "tabs": "Onglets", "bitteWaehlen": "Sélectionner...", "kurzerStatusbericht": "Bref résumé de direction...",
        "loeschen": "Supprimer", "wasWurdeEntschieden": "Qu'a-t-on décidé... ?",
        "tasksTab": "Mesures (Tâches)", "nichtGeschaetzt": "Non estimé",
        "foreignProjectNote": "Ce projet appartient à {{unit}}. Vous voyez les données du projet et les risques, mais ne pouvez pas le modifier.",
        "sharingTab": "Transmission",
        "evaluationByPortfolio": "Évalué par la gestion de portefeuille",
        "evaluationOfOrigin": "Évaluation de l'unité d'origine"
    },
    "superadmin": {
        "ausstehend": "En attente",
        "ausstehendHinweis": "Invitation envoyée, inscription pas encore terminée",
        "mandantGeloescht": "Le mandant «{{name}}» a été supprimé définitivement.",
        "fehlerLadenMandanten": "Erreur lors du chargement des mandants.",
        "fehlerMandantAnlegen": "Une erreur s'est produite lors de la création du mandant. Veuillez vérifier les données saisies.",
        "zugriffVerweigert": "Accès refusé.",
        "fehlerLadenBenutzer": "Erreur lors du chargement des utilisateurs.",
        "fehlerEinladen": "Erreur lors de l'invitation de l'utilisateur : {{msg}}",
        "rolleNichtGeaendert": "Le rôle n'a pas pu être modifié.",
        "tenantAdminErnannt": "L'utilisateur «{{email}}» a été nommé Tenant-Admin.",
        "ich": "MOI",
        "backupHinweis": "Vous pouvez exporter et importer ici les modèles globaux (critères, méthodes, informations). Utilisez cette fonction pour transférer des données du système de production vers le système de test.",
        "backupHerunterladen": "Télécharger la sauvegarde (export)",
        "backupHochladen": "Charger une sauvegarde (import)",
        "erstelle": "Création...",
        "organisationenAnzahl": "Organisations ({{count}})",
        "sperren": "Bloquer",
        "aktivieren": "Activer",
        "gesperrt": "Bloqué",
        "registrierteAssessoren": "Assesseurs enregistrés ({{count}})",
        "verwaltungMandant": "Gestion : {{name}}",
        "rolleAdmin": "Admin",
        "alsTenantAdminBenennen": "Nommer Tenant-Admin",
        "emailPlatzhalterAdmin": "admin@entreprise.ch",
        "emailPlatzhalterNeu": "nouveau@entreprise.ch",
        "benutzerExistiertText": "L'utilisateur avec l'adresse e-mail <strong>{{email}}</strong> est déjà enregistré dans le système (éventuellement avec un autre rôle ou dans un autre mandant).",
        "loesungText": "<strong>Solution :</strong> veuillez utiliser la fonction «Modifier» de la liste pour adapter les rôles au lieu d'envoyer une nouvelle invitation.",
        "benutzerEntfernenFrage": "Voulez-vous vraiment retirer l'utilisateur <strong>{{email}}</strong> de ce mandant ?",
        "mandantLoeschenTitel": "ATTENTION : supprimer le mandant «{{name}}» ?",
        "assessorLoeschenTitel": "ATTENTION : supprimer l'assesseur «{{email}}» ?",
        "mandantLoeschenText": "Cette action supprime définitivement le mandant <strong>avec toutes ses données</strong> (évaluations, mesures, utilisateurs, journaux).",
        "alleBenutzerLoginsGeloescht": "Tous les accès utilisateur seront supprimés.",
        "alleBenutzerLoginsGeloeschtAnzahl": "Les {{count}} accès utilisateur seront supprimés.",
        "fremdbewertungenGeloeschtMarkiert": "Les évaluations externes chez les assesseurs externes seront marquées «SUPPRIMÉ».",
        "ok": "OK",
        "fehler": "Erreur", "systemAdministratoren": "Administrateurs système",
        "datenManagementGlobal": "Gestion des données (Global)", "erfolg": "Succès",
        "nameAdmin": "Nom de l'admin", "keineMandantenGefunden": "Aucun mandant trouvé.",
        "externeBeraterOhneEigeneOrganisation": "Consultants externes sans leur propre organisation",
        "keineExternenAssessorenGefunden": "Aucun assesseur externe trouvé.",
        "nameEMail": "Nom / E-Mail", "firma": "Entreprise", "status": "Statut", "aktionen": "Actions",
        "benutzerHinzufuegen": "Ajouter un utilisateur", "eMail": "E-Mail", "name": "Nom", "rolle": "Rôle",
        "einladungErfolgreich": "Invitation envoyée avec succès !", "link": "Lien :", "linkKopieren": "Copier le lien",
        "vorhandeneBenutzer": "Utilisateurs existants", "ladeBenutzer": "Chargement des utilisateurs...",
        "keineBenutzerGefunden": "Aucun utilisateur trouvé.", "user": "Utilisateur",
        "benutzerBearbeiten": "Modifier l'utilisateur", "benutzer": "Utilisateur", "abbrechen": "Annuler",
        "benutzerExistiertBereits": "L'utilisateur existe déjà",
        "derBenutzerMitDerE": "L'utilisateur avec l'adresse e-mail",
        "loesung": "Solution :", "verstanden": "Compris",
        "moechtenSieDenBenutzer": "Voulez-vous supprimer l'utilisateur",
        "dieseAktionLoeschtDenMandanten": "Cette action supprime le mandant",
        "alleErstelltenAssessmentsGehenVerloren": "Toutes les évaluations créées seront perdues.",
        "diesKannNichtRueckgaengigGemacht": "Cette action est irréversible.",
        "dieseAktionLoeschtDasAssessor": "Cette action supprime définitivement le compte de l'assesseur et l'espace de travail personnel.",
        "derLoginWirdUngueltig": "La connexion deviendra invalide.",
        "lokalGespeicherteEntwuerfeWerdenGeloescht": "Les brouillons stockés localement seront supprimés.",
        "derAssessorWirdAusAllen": "L'assesseur sera retiré de toutes les listes de mandants.",
        "musterfirmaAg": "Entreprise Exemple SA", "maxMustermann": "Jean Dupont", "suchen": "Rechercher...",
        "benutzerVerwalten": "Gérer les utilisateurs",
        "mandantUnwiderruflichLoeschenDangerZone": "Supprimer définitivement le mandant (Zone de danger)",
        "assessorUnwiderruflichLoeschenDangerZone": "Supprimer définitivement l'assesseur (Zone de danger)",
        "bearbeiten": "Modifier", "loeschen": "Supprimer", "benutzerLoeschen": "Supprimer l'utilisateur",
        "tenantList": "Liste des mandants",
        "assessorList": "Liste des assesseurs",
        "userList": "Liste des utilisateurs",
        "roleMember": "Personne du mandant (les rôles fonctionnels sont attribués par le Tenant-Admin)",
        "roleTenantAdmin": "Tenant-Admin (structure, personnes, paramètres)"
    },
    "usermanagement": {
        "einladungAusstehend": "Invitation en attente",
        "ladenFehlgeschlagen": "Chargement échoué", "externerAssessor": "Assesseur externe",
        "schliessen": "Fermer", "benutzerExistiertBereits": "L'utilisateur existe déjà",
        "derBenutzerMitDerE": "L'utilisateur avec l'adresse e-mail", "tipp": "Conseil :", "verstanden": "Compris",
        "assessorNichtGefunden": "Assesseur non trouvé",
        "wirKonntenKeinenRegistriertenAssessor": "Nous n'avons pas trouvé d'assesseur enregistré avec l'adresse e-mail",
        "hinweis": "Remarque :", "benutzerBearbeiten": "Modifier l'utilisateur",
        "zugriffEntfernen": "Supprimer l'accès", "ausMandantEntfernen": "Retirer du mandant",
        "dieEmail": "L'adresse e-mail",
        "esWurdeKeinAssessorMitDerEmail": "Aucun assesseur enregistré avec l'adresse e-mail"
    },
    "richTextEditor": {
        "bold": "Gras",
        "italic": "Italique",
        "bulletList": "Liste à puces"
    },
    "kanbanboard": {
        "wipLimitReachedIntro": "La limite WIP configurée pour la colonne «{{column}}» est déjà atteinte dans les buckets de capacité suivants :",
        "wipLimitBottleneckHint": "L'expérience montre que le déplacement de mesures supplémentaires entraîne des goulets d'étranglement et des retards dans les tâches en cours.",
        "wipLimitConfirmQuestion": "Voulez-vous <strong>quand même</strong> mettre cette mesure en cours en raison de priorités urgentes ?",
        "promise": "Promise", "kapazitaetsauslastung": "Utilisation des capacités",
        "ungueltigeVerantwortlichkeit": "Responsabilité invalide", "wipLimitUeberschritten": "Limite WIP dépassée",
        "abbrechen": "Annuler", "trotzdemFortfahren": "Continuer quand même",
        "dieserBenutzerIstNichtTeil": "Cet utilisateur ne fait pas partie de l'équipe du projet"
    },
    "projectcategoryselect": { "ownGroup": "Catégories propres", "topicGroup": "Thèmes transversaux", "ownerUnknown": "unité responsable", "topicLocked": "Les thèmes transversaux sont attribués par la gestion de portefeuille de l'unité d'origine.", "visibleFor": "visible pour {{unit}}", "sharedWith": "Visible grâce aux thèmes transversaux pour : {{units}} (données du projet et risques, sans mesures)", "keineKategorie": "Aucune catégorie", "keineKategorienGefunden": "Aucune catégorie trouvée", "searchCategory": "Rechercher une catégorie..." },
    "projectriskstab": { "schaden": "Dommage :", "wahrsch": "Prob. :", "score": "Score :" },
    "projectroadmap": {
        "unbenannt": "Sans titre",
        "meilenstein": "Jalon : {{title}}",
        "keineProjekteFuerRoadMap": "Aucun projet trouvé pour la feuille de route.",
        "sortierenNach": "Trier par :", "ohneKategorie": "Sans catégorie", "ohneDatum": "Sans date",
        "showCategories": "Afficher les catégories", "hideCategories": "Masquer les catégories",
        "sortAlphabetical": "Alphabétique", "sortStartDate": "Date de début", "sortEndDate": "Date cible"
    },
    "projectsettings": {
        "sie": "Vous",
        "feldnamePlaceholder": "ex. Priorité, Coûts...",
        "bucketNamePlaceholder": "ex. Grands projets",
        "wipLimitUmschalten": "Activer ou désactiver la limite WIP",
        "entfernenHinweis": "Si vous le retirez, ces mesures lui restent attribuées pour l'instant, mais il sera signalé en couleur comme «Responsabilité invalide». Les mesures devraient ensuite être attribuées à un autre membre du projet.",
        "promise": "Promise", "projektEinstellungen": "Paramètres du projet", "mitglieder": "Membres",
        "labels": "Étiquettes", "projektMitglieder": "Membres du projet", "verantwortlich": "Responsable",
        "projektLabels": "Étiquettes du projet",
        "definierenSieProjektweiteLabelsDie": "Définissez des étiquettes à l'échelle du projet pouvant être assignées aux tâches pour une meilleure structuration.",
        "neuesLabelErstellen": "Créer une nouvelle étiquette", "hinzufuegen": "Ajouter", "verfuegbareLabels": "Étiquettes disponibles",
        "labelsWerdenGeladen": "Chargement des étiquettes...", "keineLabelsDefiniert": "Aucune étiquette définie.",
        "pflicht": "Obligatoire", "keineBucketsDefiniert": "Aucun bucket défini.", "bucketName": "Nom du bucket",
        "aufwandgroessenTShirt": "Tailles d'effort (T-Shirt)", "wipLimit": "Limite WIP",
        "taskGroupsTitle": "Groupes de mesures",
        "taskGroupsDescription": "Regroupez les mesures par phases ou objectifs (ex. Phase 1, Phase 2). Ces groupes peuvent être visualisés sur la feuille de route.",
        "addGroup": "+ Ajouter un groupe",
        "groupName": "Nom du groupe (ex. Phase 1)",
        "groupDeleteWarning": "Attention : Les mesures de ce groupe seront assignées au groupe 'Aucun'.",
        "achtungOffeneMassnahmen": "Attention : Mesures ouvertes",
        "dieserBenutzerHatNoch": "Cet utilisateur a encore",
        "moechtenSieDenBenutzerTrotzdem": "Voulez-vous quand même retirer l'utilisateur ?",
        "abbrechen": "Annuler", "trotzdemEntfernen": "Retirer quand même",
        "labelNameZBBug": "Nom de l'étiquette (ex. Bug, Fonctionnalité, Important)",
        "labelFarbeWaehlen": "Choisir la couleur de l'étiquette", "labelLoeschen": "Supprimer l'étiquette",
        "feldAktivieren": "Activer le champ", "pflichtfeld": "Champ obligatoire", "feldEntfernen": "Supprimer le champ", "loeschen": "Supprimer",
        "zugewiesen": "attribuée(s)."
    },
    "projectSettings": {
        "labelsLoadError": "Erreur lors du chargement des étiquettes.",
        "deleteLabelError": "Erreur lors de la suppression de l'étiquette.",
        "tasksTab": "Mesures", "customFieldsTitle": "Champs spécifiques au projet",
        "customFieldsDescription": "Définissez jusqu'à 3 champs supplémentaires pour les mesures de ce projet.",
        "fieldLabel": "Nom du champ", "fieldType": "Type de champ", "fieldTypeText": "Champ texte",
        "fieldTypeCheckbox": "Case à cocher", "fieldTypeDropdown": "Liste déroulante",
        "dropdownOptions": "Options de sélection", "dropdownOptionsHint": "Séparées par des virgules (ex. Option A, Option B)",
        "addField": "+ Ajouter un champ", "maxFieldsReached": "Maximum 3 champs autorisés.",
        "taskWipLimitTitle": "Limite WIP (Mesures)", "taskWipLimitDescription": "Contrôle le nombre de mesures simultanées en phase «En cours» à l'aide de buckets de capacité définis.",
        "taskWipLimitLabel": "Nombre maximum", "taskWipLimitDisabled": "Pas de limite",
        "saveSettings": "Enregistrer les paramètres", "membersSaveError": "Erreur d'enregistrement des membres.",
        "measuresSaveError": "Erreur d'enregistrement des paramètres de mesures.",
        "membersDescription": "Sélectionnez les personnes pouvant accéder à ce projet et collaborer aux tâches. Les utilisateurs de niveau 30 et les administrateurs ont de toute façon accès à tous les projets.",
        "wipBucketsConfig": "Configuration des buckets de capacité", "addBucket": "+ Ajouter un bucket",
        "automZugriff": "Accès autom. (Niv {{level}})",
        "membersFooterHint": "Les modifications ne prennent effet qu'après l'enregistrement.",
        "tasksFooterHint": "Les champs et les limites WIP sont enregistrés par projet.",
        "labelsFooterHint": "Les étiquettes sont créées et supprimées immédiatement.",
        "updateLabelError": "Erreur lors de la mise à jour de l'étiquette.",
        "membersDescriptionV2": "Sélectionnez les personnes autorisées à accéder à ce projet et à collaborer aux mesures. La gestion de portefeuille et le management de l'unité d'origine y ont accès dans tous les cas.",
        "automZugriffPortfolio": "Accès auto. (portefeuille)",
        "pendingNew": "Nouveau",
        "taskGroupsTitle": "Groupes de mesures",
        "taskGroupsDescription": "Regroupez les mesures en phases ou en objectifs (ex. Phase 1, Phase 2). Ces groupes peuvent être visualisés sur la feuille de route.",
        "addGroup": "+ Ajouter un groupe",
        "groupName": "Nom du groupe (ex. Phase 1)",
        "groupDeleteWarning": "Attention : les mesures de ce groupe seront attribuées au groupe 'Aucun'.",
        "keineGruppen": "Aucun groupe de mesures défini.",
        "openMeasure": "mesure ouverte",
        "openMeasures": "mesures ouvertes"
    },
    "projecttaskmanagement": {
        "neueAufgabe": "Nouvelle tâche",
        "aufgabeHinzufuegen": "+ Ajouter une tâche",
        "promise": "Promise", "timelineGanttAnsicht": "Vue Timeline / Gantt",
        "dieseAnsichtWirdInEinem": "Cette vue sera étendue dans une future mise à jour. Elle permettra de planifier visuellement les tâches.",
        "liste": "Liste", "board": "Tableau", "timeline": "Chronologie"
    },
    "risk": { "promise": "Promise" },
    "taskdetail": {
        "commentsLoadError": "Erreur lors du chargement des commentaires.",
        "commentDeleteError": "Le commentaire n'a pas pu être supprimé.",
        "unknownUser": "Personne inconnue",
        "allProjectMembers": "Tous les membres du projet",
        "kommentarWirklichLoeschen": "Voulez-vous vraiment supprimer ce commentaire ?",
        "keineAuswahl": "– Aucune sélection –",
        "status": "Statut",
        "promise": "Promise", "ungueltigeVerantwortlichkeit": "Responsabilité invalide",
        "dieAktuellZugewiesenePersonIst": "La personne actuellement assignée ne fait pas partie de l'équipe du projet. Veuillez assigner la mesure à un membre valide.",
        "beschreibung": "Description", "checkliste": "Liste de contrôle", "verantwortlich": "Responsable",
        "startdatum": "Date de début", "faelligkeitsdatum": "Date d'échéance", "erinnerungsdatum": "Date de rappel",
        "massnahmengruppe": "Groupe de mesures",
        "keineGruppe": "Aucun groupe",
        "kommentareVerlauf": "Commentaires & Historique", "ladeKommentare": "Chargement des commentaires...",
        "keineKommentareVorhanden": "Aucun commentaire disponible.", "worumGehtEs": "De quoi s'agit-il ?",
        "aufDemKanbanBoardAnzeigen": "Afficher sur le tableau Kanban",
        "detaillierteBeschreibungDerAufgabe": "Description détaillée de la tâche...",
        "neuerEintrag": "Nouvelle entrée...", "loeschen": "Supprimer",
        "neueAufgabeErstellen": "Créer une nouvelle tâche", "aufgabeBearbeiten": "Modifier la tâche",
        "titelDerAufgabe": "Titre de la tâche", "schliessen": "Fermer", "abbrechen": "Annuler",
        "wirdGespeichert": "Enregistrement...", "aufgabeSpeichern": "Enregistrer la tâche",
        "neuenKommentarSchreiben": "Écrire un commentaire... (tapez @ pour mentionner)",
        "sendError": "Erreur lors de l'envoi du commentaire", "nichtGeschaetzt": "Non estimé",
        "sKlein": "S (Petit)", "mMittel": "M (Moyen)", "lGross": "L (Grand)", "xlSehrGross": "XL (Très grand)",
        "checkliste.eintragErledigt": "Marquer l'élément comme terminé",
        "checkliste.eintragTitel": "Titre de l'élément de la liste de contrôle",
        "checkliste.entfernen": "Supprimer l'élément de la liste de contrôle"
    },
    "tasklabelselect": {
        "wirdErstellt": "Création en cours...",
        "labelErstellen": "Créer l'étiquette «{{name}}»",
        "farbeAuswaehlen": "Choisir la couleur {{color}}",
        "promise": "Promise", "keineLabelsGefunden": "Aucune étiquette trouvée.",
        "neuesLabelErstellen": "Créer une nouvelle étiquette", "labelsAuswaehlen": "Sélectionner des étiquettes..."
    },
    "tasklist": {
        "unbenannteMassnahme": "Mesure sans titre",
        "promise": "Promise", "massnahmenTasks": "Mesures (Tâches)", "nochKeineMassnahmenDefiniert": "Aucune mesure définie.",
        "nichtZugewiesen": "Non assigné", "ungueltig": "Responsabilité invalide",
        "dieserBenutzerIstNichtTeil": "Cet utilisateur ne fait pas partie de l'équipe du projet", "loeschen": "Supprimer",
        "columns": { "title": "Mesure", "status": "Statut", "dueDate": "Date cible", "assignee": "Responsable", "checkbox": "Statut", "actions": "Actions" },
        "toggleStatus": "Changer le statut"
    },
    "taskroadmap": {
        "verschieben": "Modifier l'ordre",
        "meilenstein": "Jalon : {{title}}",
        "keineMassnahmenFuerZeitleisteGefunden": "Aucune mesure trouvée pour la chronologie.",
        "sortierenNach": "Trier par :", "ohneLabel": "Sans étiquette", "ohneDatum": "Sans date",
        "ohneGruppe": "Sans groupe",
        "gruppierenNach": "Regrouper par :",
        "keine": "Aucun",
        "massnahmengruppe": "Groupe de mesures",
        "hideGroups": "Masquer les groupes",
        "showGroups": "Afficher les groupes",
        "hideLabels": "Masquer les étiquettes", "showLabels": "Afficher les étiquettes",
        "sortAlphabetical": "Alphabétique", "sortStartDate": "Date de début", "sortEndDate": "Date de fin"
    },
    "assessmentchart": { "punkte": "Points", "keineDatenVerfuegbar": "Aucune donnée disponible." },
    "cafinteractivemodel": { "befaehiger": "Facteurs", "ergebnisse": "Résultats" },
    "createproject": {
        "promise": "Promise", "neuesProjektErstellen": "Créer un nouveau projet",
        "aiTitelVorschlagen": "Suggérer un titre par IA", "projektbewertungPriorisierung": "Évaluation & Priorisation du projet",
        "gesetzlicherAuftrag": "Mandat légal", "istDiesesProjektZwingendUmzusetzen": "Ce projet est-il obligatoire ?",
        "abbrechen": "Annuler", "bitteWaehlen": "Veuillez sélectionner...", "wirdErstellt": "Création...", "projektErstellen": "Créer le projet"
    },
    "dangerconfirmation": {
        "zurBestaetigungTippenSieBitte": "Pour confirmer, veuillez saisir",
        "grossUndKleinschreibungMussBeachten": "La casse doit être respectée.", "abbrechen": "Annuler",
        "loeschen": "Suppression...", "endgueltigLoeschen": "Supprimer définitivement"
    },
    "deleteconfirmation": { "loeschen": "Suppression..." },
    "errorboundary": { "error": "Erreur :" },
    "mfaverification": { "promise": "Promise", "close": "Fermer", "code": "Code" },
    "notificationbell": {
        "benachrichtigungen": "Notifications", "alleAlsGelesenMarkieren": "Tout marquer comme lu",
        "keineBenachrichtigungenVorhanden": "Aucune notification disponible."
    },
    "notifications": {
        "reminder": "Rappel", "mention": "Nouvelle mention",
        "reorganization": "Unité déplacée"
    },
    "permissionselection": {
        "berechtigungsLevelAuswaehlen": "Sélectionner le rôle et les autorisations",
        "waehlenSieDieZutreffendeRolle": "Sélectionnez le rôle fonctionnel pour cet utilisateur au sein de son unité organisationnelle.",
        "roleSelectionTitle": "Sélectionner le rôle et les autorisations",
        "roleSelectionSubtitle": "Sélectionnez le rôle fonctionnel pour cet utilisateur au sein de son unité organisationnelle.",
        "roles": {
            "qm_management": {
                "title": "QM-Management",
                "description": "Crée, duplique, supprime et publie les évaluations CAF. Effectue la priorisation stratégique des projets et contrôle la transmission vers les échelons supérieurs.",
                "descriptionV2": "Responsable de l'autoévaluation CAF de l'unité : la crée, la clôture et la partage avec l'unité supérieure. Voit les évaluations partagées par les unités subordonnées."
            },
            "management": {
                "title": "Management",
                "description": "Visibilité complète sur tous les projets de l'unité. Participe activement à l'auto-évaluation CAF (saisie des scores, points forts et potentiels).",
                "descriptionV2": "Direction de l'unité. Participe à l'évaluation CAF et dispose d'un accès en lecture à toutes les données CAF et de portefeuille de l'unité."
            },
            "project_management": {
                "title": "Chef de projet",
                "description": "Direction opérationnelle de ses propres projets. Gère les détails, jalons, risques, feux tricolores et mesures.",
                "descriptionV2": "Crée des projets et dirige ses propres projets (détails, risques, mesures)."
            },
            "project_team": {
                "title": "Équipe de projet",
                "description": "Exécute les mesures et tâches assignées (mise à jour des statuts, listes de contrôle, commentaires).",
                "descriptionV2": "Traite les mesures attribuées dans les projets auxquels la personne participe."
            },
            "portfolio_management": {
                "title": "Gestion de portefeuille",
                "description": "Pilote le portefeuille de projets de l'unité : priorise et évalue les projets, les transmet à l'unité supérieure et attribue les thèmes transversaux."
            }
        },
        "addons": {
            "isOrgAdmin": {
                "title": "Admin d'organisation",
                "description": "Autorise l'utilisateur à inviter et gérer ses collègues au sein de sa propre unité organisationnelle."
            },
            "isTenantAdmin": {
                "title": "Tenant-Admin",
                "description": "Gère la structure organisationnelle N-Level, les paramètres globaux et nomme les admins d'organisation.",
                "descriptionV2": "Gère la structure organisationnelle, les personnes, les paramètres et les thèmes transversaux. Ne voit pas les contenus des autres unités."
            }
        },
        "levels": {
            "50": { "title": "Tenant-Admin", "description": "Gère la structure organisationnelle, les paramètres globaux et nomme les admins d'organisation." },
            "40": { "title": "QM-Management", "description": "Créer, publier et supprimer les évaluations CAF. Priorisation stratégique des projets." },
            "30": { "title": "Management", "description": "Participation active aux évaluations CAF et visibilité complète sur tous les projets de l'unité." },
            "20": { "title": "Chef de projet", "description": "Diriger ses propres projets, risques et mesures." },
            "10": { "title": "Équipe de projet", "description": "Travailler sur les tâches et mesures assignées." }
        },
        "rolesSelectionTitle": "Sélectionner les rôles fonctionnels",
        "rolesSelectionSubtitle": "Les rôles s'appliquent dans l'unité organisationnelle de la personne. Plusieurs rôles sont possibles.",
        "apply": "Appliquer",
        "rolesTitle": "Rôles fonctionnels"
    },
    "principlesbubbles": { "grundsaetzeDerExzellenz": "Principes d'excellence" },
    "screenshotcarousel": { "bildNummer": "Image {{number}} : {{title}}", "bildWirdSpaeterEingefuegt": "Image à insérer ultérieurement", "vorherigesBild": "Image précédente", "naechstesBild": "Image suivante" },
    "ssoconfigsection": { "fehlerKonfiguration": "Erreur lors de la configuration SSO.", "fehlerEntfernen": "Erreur lors de la suppression de la configuration SSO.", "clientIdPlaceholder": "ex. 12345678-abcd-1234-abcd-1234567890ab", "issuerUrlPlaceholder": "ex. https://login.microsoftonline.com/{tenant-id}/v2.0", "saml20": "SAML 2.0", "openidConnectOidc": "OpenID Connect (OIDC)", "clientId": "Client ID", "issuerUrl": "URL d'émetteur" },
    "assessmentwizard": { "durchschnitt": "Moyenne" },
    "clientselection": {
        "neuenBewertungErstellen": "Créer une nouvelle évaluation",
        "bitteWaehlenSieDenMandanten": "Veuillez sélectionner le mandant pour lequel vous souhaitez créer cette évaluation.",
        "keineAktivenMandantenGefunden": "Aucun mandant actif trouvé.", "abbrechen": "Annuler"
    },
    "editremark": { "bemerkungBearbeiten": "Modifier la remarque", "text": "Texte", "urlOptional": "URL (Facultatif)", "promise": "Promise" },
    "exportcontent": {
        "pdfErstellen": "Créer le PDF",
        "generiere": "Génération...",
        "inhalteAlsPdfExportieren": "Exporter le contenu en PDF",
        "waehlenSieDieZuExportierenden": "Sélectionnez le contenu à exporter.",
        "methodenbaukasten": "Boîte à méthodes", "themenfelderKriterien": "Thèmes & Critères",
        "informationsbereiche": "Sections d'information", "abbrechen": "Annuler"
    },
    "methodeditor": {
        "titelPlatzhalter": "ex. atelier charte des valeurs",
        "bitteWaehlen": "Veuillez sélectionner...",
        "bildvorschau": "Aperçu de l'image",
        "formatHinweis": "Utilisez des retours à la ligne pour structurer le texte et des <strong>**doubles astérisques**</strong> pour le gras.",
        "titel": "Titre", "zugehoerigesKriterium": "Critère associé", "zielUndZweck": "Objectif et but",
        "beschreibungDetails": "Description / Détails", "bildOptional": "Image (Facultatif)", "bildEntfernen": "Supprimer l'image",
        "tippsHandlungsanleitung": "Conseils & Instructions",
        "nutzenSieZeilenumbruecheFuerStrukturierung": "Utilisez des sauts de ligne pour la structuration et",
        "abbrechen": "Annuler", "kurzeBeschreibungDesZiels": "Brève description de l'objectif...",
        "ausfuehrlicheBeschreibung": "Description détaillée...", "fettMarkieren": "Gras", "schrittFuerSchrittAnleitung": "Instructions étape par étape...",
        "methodeBearbeiten": "Modifier la méthode",
        "neueMethodeErstellen": "Créer une nouvelle méthode",
        "laedt": "Téléchargement...",
        "speichern": "Enregistrer"
    },
    "tenantUsers": { "bearbeiten": "Modifier", "benutzerBearbeiten": "Modifier l'utilisateur" },
    "export": {
        "title": "Exporter le rapport", "question": "Quelles sections de contenu doivent être incluses ?",
        "overview": "Vue d'ensemble des scores", "overviewDesc": "Résumé des scores par thème avec graphique radar.",
        "trendAnalysis": "Analyse des tendances à long terme", "trendAnalysisDesc": "Évolution des scores sur plusieurs évaluations.",
        "chartLoading": "Chargement du graphique...",
        "generating": "Génération en cours..."
    },
    "languageUnavailableModal": {
        "title": "Langue plus disponible",
        "message": "La langue que vous aviez sélectionnée a été désactivée par votre administrateur. Veuillez choisir l'une des langues disponibles pour continuer.",
        "selectPrompt": "Langues disponibles :",
        "saving": "Enregistrement..."
    },

    "legal": {
        "impressum": "Mentions légales",
        "datenschutz": "Politique de confidentialité",
        "nutzungsbedingungen": "Conditions d'utilisation",
        "cookieRichtlinie": "Politique relative aux cookies",
        "backToLogin": "Retour à la connexion",
        "termsTitle": "Conditions d'utilisation (Terms of Service)",
        "termsGeneralTitle": "1. Champ d'application",
        "termsGeneralContent": "Les présentes conditions d'utilisation régissent l'accès et l'utilisation de la CAF Suite (ci-après «l'Application»). L'Application est fournie exclusivement aux clients professionnels (B2B).",
        "termsContractTitle": "2. Primauté du contrat SaaS",
        "termsContractContent": "Les droits détaillés, obligations, les questions de responsabilité ainsi que les accords relatifs à la protection des données (y compris le contrat de sous-traitance) sont principalement régis par le contrat individuel Software-as-a-Service (SaaS) conclu avec votre organisation. En cas de questions juridiques ouvertes ou de contradictions, les dispositions écrites de ce contrat principal prévaudront toujours sur ces conditions cadres.",
        "termsAccessTitle": "3. Accès autorisé",
        "termsAccessContent": "L'accès à cette instance n'est autorisé qu'aux employés explicitement autorisés des organisations titulaires de licence ainsi qu'à leurs assesseurs mandatés. Les identifiants de connexion ne doivent en aucun cas être partagés avec des tiers.",
        "cookiePolicyTitle": "Politique relative aux cookies",
        "cookieNoTrackingTitle": "1. Principe : Aucun Suivi (No Tracking)",
        "cookieNoTrackingContent": "Nous respectons pleinement votre vie privée et les données sensibles de cette application. Par conséquent, nous n'utilisons aucun cookie de marketing, d'analyse ou de suivi (par ex., Google Analytics) dans la CAF Suite. Nous utilisons exclusivement des mécanismes strictement nécessaires sur le plan technique pour garantir les fonctionnalités de base et la sécurité du système.",
        "cookieAuthTitle": "2. Authentification et gestion de session",
        "cookieAuthContent": "Pour une connexion sécurisée et le maintien de votre session active, des jetons de session cryptés (JSON Web Tokens) sont stockés dans votre navigateur (LocalStorage / IndexedDB). Ces jetons sont liés à la sécurité et strictement nécessaires techniquement pour que votre connexion n'expire pas immédiatement pendant l'utilisation.",
        "cookieCloudflareTitle": "3. Cloudflare Turnstile (Prévention des bots)",
        "cookieCloudflareContent": "Pour protéger les écrans de connexion sensibles contre les attaques par force brute automatisées, nous utilisons Cloudflare Turnstile. Ce service analyse des métadonnées du navigateur purement techniques en arrière-plan mais s'abstient totalement de tout suivi inter-appareils des utilisateurs et ne place absolument aucun cookie de suivi."
    },
    "cookies": {
        "bannerText": "Nous utilisons exclusivement des cookies et mécanismes de stockage strictement nécessaires (par ex., pour les sessions de connexion) pour assurer la sécurité et la fonctionnalité de cette plateforme. Aucun cookie de suivi ou marketing n'est utilisé.",
        "bannerTitle": "Avis relatif aux cookies",
        "accept": "Compris",
        "policyLink": "En savoir plus"
    },
    "localizedFields": {
        "language": "Langue",
        "hint": "Remplir au moins une langue. Lorsqu'une langue manque, le texte de la première langue remplie s'affiche."
    },
    "tenantLock": {
        "unlock": "Débloquer",
        "lockDialog": {
            "title": "Bloquer le mandant «{{name}}» ?",
            "intro": "Bloqué signifie : aucun accès pour les personnes de ce mandant.",
            "signOut": "Toutes les personnes du mandant sont déconnectées et ne peuvent plus se connecter.",
            "assessors": "Les assesseurs externes ne peuvent plus soumettre d'évaluations à ce mandant.",
            "noInvites": "Il n'est plus possible d'ajouter des personnes ni des assesseurs.",
            "dataKept": "Les données sont conservées. Vous pouvez toujours les exporter.",
            "reversible": "Le déblocage rétablit l'accès.",
            "confirm": "Bloquer le mandant"
        },
        "unlockDialog": {
            "title": "Débloquer le mandant «{{name}}» ?",
            "message": "Les personnes du mandant peuvent à nouveau se connecter et retrouvent leur accès habituel. Les comptes déjà désactivés avant le blocage restent désactivés.",
            "confirm": "Débloquer le mandant"
        },
        "result": {
            "lockedTitle": "Mandant «{{name}}» bloqué",
            "unlockedTitle": "Mandant «{{name}}» débloqué",
            "unlockIncompleteTitle": "Le mandant «{{name}}» reste bloqué",
            "people": "Personnes du mandant : {{n}}",
            "disabled": "Comptes de connexion désactivés : {{n}}",
            "enabled": "Comptes de connexion réactivés : {{n}}",
            "skipped": "Ignorées faute de compte de connexion : {{n}}",
            "lockErrors": "Comptes qui n'ont pas pu être désactivés : {{n}}. Ces personnes n'ont malgré tout aucun accès aux données. Vous trouverez les détails dans Cloud Logging.",
            "unlockErrors": "Comptes qui n'ont pas pu être réactivés : {{n}}. Le mandant reste bloqué. Veuillez le débloquer à nouveau ; vous trouverez les détails dans Cloud Logging."
        },
        "export": {
            "action": "Exporter les données",
            "running": "Exportation des données …",
            "failedTitle": "Échec de l'exportation",
            "noLink": "L'exportation n'a fourni aucun lien de téléchargement. Veuillez réessayer."
        },
        "page": {
            "title": "Mandant bloqué",
            "message": "Votre mandant est bloqué. Vous n'avez plus accès à la CAF Suite ; vos données sont conservées. Veuillez vous adresser à votre organisation ou au support.",
            "logout": "Se déconnecter"
        },
        "loginDisabled": "Votre compte est désactivé, par exemple parce que votre mandant est bloqué. Veuillez vous adresser à votre organisation ou au support."
    },
    "orgTree": {
        "title": "Structure organisationnelle",
        "subtitle": "Gestion hiérarchique de toutes les unités organisationnelles (N-Level)",
        "addChildUnit": "Créer une unité subordonnée",
        "unitName": "Nom de l'unité",
        "unitCode": "Abréviation",
        "headcountFTE": "Équivalents plein temps (EPT)",
        "portfolioManagers": "Responsables de portefeuille de projets (PPM)",
        "unitLeads": "Direction de l'unité",
        "reparentSubtree": "Déplacer la sous-arborescence",
        "newParent": "Nouvelle unité supérieure",
        "confirmDelete": "Supprimer l'unité organisationnelle ?",
        "deleteWarning": "Aucune unité subordonnée ou projet actif ne doit être rattaché.",
        "fetchError": "Erreur lors du chargement de la structure organisationnelle.",
        "breadcrumbAriaLabel": "Chemin organisationnel",
        "assignedOrgUnit": "Unité organisationnelle assignée",
        "selectOrgUnit": "Sélectionner une unité organisationnelle...",
        "sharingScope": "Visibilité / Portée de partage",
        "sharingScopeUpward": "Incl. niveaux hiérarchiques supérieurs (Rollup CAF)",
        "sharingScopeTenant": "Visible à l'échelle du mandant",
        "sharingScopeParentOnly": "Niveau supérieur direct uniquement",
        "sharingScopeConfidential": "Confidentiel (Cette unité uniquement)",
        "noOrgUnitAssigned": "Aucune unité assignée (à l'échelle du mandant)",
        "createdAnnounce": "Unité organisationnelle créée avec succès.",
        "createError": "Erreur lors de la création.",
        "updatedAnnounce": "Unité organisationnelle mise à jour avec succès.",
        "updateError": "Erreur lors de la mise à jour.",
        "reparentedAnnounce": "Unité organisationnelle déplacée avec succès.",
        "reparentError": "Erreur lors du déplacement.",
        "reactivatedAnnounce": "Unité organisationnelle réactivée.",
        "deactivatedAnnounce": "Unité organisationnelle désactivée.",
        "deletedAnnounce": "Unité organisationnelle supprimée.",
        "deleteError": "Erreur lors de la suppression.",
        "inactive": "désactivée",
        "reactivate": "Réactiver",
        "deactivate": "Désactiver",
        "deleteHint": "Supprimer (uniquement sans sous-unités, personnes ni données)",
        "subtitleLevels": "Hiérarchie des unités organisationnelles, {{max}} niveaux au maximum.",
        "noUnitsFound": "Aucune unité organisationnelle créée pour l'instant.",
        "createChildUnder": "Nouvelle unité sous «{{parentName}}»",
        "editUnitTitle": "Modifier l'unité organisationnelle",
        "unitCodePlaceholder": "ex. AFI",
        "unitDescription": "Description",
        "reparentHelp": "Sélectionnez la nouvelle unité supérieure pour «{{unitName}}». Toutes les sous-unités sont déplacées avec elle.",
        "confirmReparent": "Déplacer",
        "addRootUnitV2": "Créer l'unité supérieure",
        "missingLanguages": "{{languages}} manquant",
        "insertRoot": "Insérer une unité supérieure",
        "insertRootHint": "Insérer une nouvelle unité au-dessus de celle-ci, p. ex. lorsqu'un département rejoint l'ensemble du canton",
        "insertRootFull": "La structure compte déjà {{max}} niveaux.",
        "removeRoot": "Retirer l'unité supérieure",
        "confirmRemoveRoot": "Retirer «{{root}}» ? «{{child}}» redevient l'unité supérieure et donne son nom au mandant. Ce n'est possible que tant que personne n'est rattaché à «{{root}}» et que rien ne lui a été partagé ou transmis.",
        "rootInsertedAnnounce": "Unité supérieure insérée.",
        "insertRootError": "L'unité n'a pas pu être insérée.",
        "rootRemovedAnnounce": "Unité supérieure retirée.",
        "removeRootError": "L'unité supérieure n'a pas pu être retirée.",
        "previewError": "Les conséquences n'ont pas pu être déterminées.",
        "previewLoading": "Détermination des conséquences …",
        "noConsequences": "Aucun partage ni aucune transmission n'est annulé.",
        "subunitsMoved_one": "1 sous-unité est déplacée avec elle.",
        "subunitsMoved_other": "{{count}} sous-unités sont déplacées avec elle.",
        "irreversibleTitle": "Les éléments suivants ne peuvent pas être annulés :",
        "releasesWithdrawn_one": "1 évaluation partagée avec «{{parent}}» ({{years}}) est retirée. «{{parent}}» ne la voit plus, y compris dans les analyses des années précédentes.",
        "releasesWithdrawn_other": "{{count}} évaluations partagées avec «{{parent}}» ({{years}}) sont retirées. «{{parent}}» ne les voit plus, y compris dans les analyses des années précédentes.",
        "consequencesKept": "Sont conservés : toutes les données de l'unité, les thèmes transversaux et les partages au sein de la partie déplacée. L'unité peut à nouveau partager ses évaluations et transmettre ses projets à la nouvelle unité supérieure ; sa gestion de la qualité et sa gestion de portefeuille sont notifiées.",
        "confirmConsequences": "J'ai compris les conséquences.",
        "insertRootIntro": "La nouvelle unité est insérée au-dessus de «{{root}}», par exemple lorsqu'un département rejoint l'ensemble du canton.",
        "new": "nouveau",
        "subunitsCount_one": "1 sous-unité comme jusqu'ici",
        "subunitsCount_other": "{{count}} sous-unités comme jusqu'ici",
        "insertRootNothingRevoked": "Aucun partage ni aucune transmission n'est annulé. Toutes les unités conservent leurs personnes, évaluations et projets.",
        "insertRootReleaseLater": "«{{root}}» pourra ensuite partager ses évaluations et transmettre ses projets à «{{name}}».",
        "insertRootLevels": "La structure comptera ensuite {{levels}} niveaux (au maximum {{max}}).",
        "insertRootTenantName": "Le mandant s'appellera ensuite «{{name}}». Le nom de l'unité supérieure est toujours aussi celui du mandant.",
        "insertRootAdmins": "Les droits d'administrateur du mandant valent pour tout le mandant, donc désormais pour toute la nouvelle organisation : toutes les personnes, la structure et l'export complet des données.",
        "insertRootAdminsToday": "Actuellement, ils sont détenus par : {{names}}.",
        "insertRootAdminsCheck": "Vérifiez ensuite dans la gestion des utilisateurs qui doit les détenir.",
        "insertRootPeople": "Les personnes restent dans leur unité. Personne n'est encore rattaché à la nouvelle unité supérieure.",
        "insertRootOperator": "L'exploitant de la CAF Suite est informé de la modification.",
        "insertRootUndo": "Cette opération peut être annulée tant que personne n'est rattaché à la nouvelle unité et que rien ne lui a été partagé ou transmis.",
        "rootNameIsTenantName": "Le nom de l'unité supérieure est aussi le nom du mandant.",
        "unitDescriptionInternal": "Description (note interne)",
        "reparentNamed": "Déplacer «{{unitName}}»",
        "wizardSteps": "Étapes",
        "wizardStepName": "Nom",
        "wizardStepPreview": "Aperçu",
        "wizardStepAdmin": "Administration",
        "insertRootConfirm": "Insérer l'unité",
        "promotionsRevokedAt_one": "1 transmission de projet est annulée (jusqu'ici chez {{units}}).",
        "promotionsRevokedAt_other": "{{count}} transmissions de projets sont annulées (jusqu'ici chez {{units}})."
    },
    "governance": {
        "topicsVisibleFor": "Visible pour : {{list}}",
        "topicsWhere": "Les thèmes transversaux sont attribués par la gestion de portefeuille de l'unité d'origine dans le champ «Catégories».",
        "stepperTitle": "Pipeline de promotion des projets clés",
        "stepperSubtitle": "Transmission progressive aux portefeuilles supérieurs sans escalade automatique",
        "stepperAriaLabel": "Parcours d'approbation hiérarchique",
        "promotedSuccessAnnounce": "Le projet a été promu à {{unitName}}.",
        "revokedSuccessAnnounce": "La promotion pour {{unitName}} a été révoquée.",
        "promotedByOn": "Promu par {{name}} le {{date}}",
        "promoteAction": "Promouvoir",
        "revokeAction": "Révoquer la promotion",
        "promoteModalTitle": "Promouvoir le projet au niveau supérieur",
        "promoteModalSubtitle": "Promotion de «{{from}}» vers «{{to}}»",
        "promotionCommentLabel": "Justification / Note pour le portefeuille supérieur (optionnel)",
        "promotionCommentPlaceholder": "ex. Répond aux critères de priorité départementale.",
        "confirmPromote": "Promouvoir maintenant",
        "levelEvaluationTitle": "Évaluation stratégique : {{unitName}}",
        "levelEvaluationSubtitle": "Priorisation stratégique spécifique à ce portefeuille",
        "executiveVaultBadge": "Executive Vault (Confidentiel)",
        "originLevelScoringHint": "Au niveau d'origine, la priorisation stratégique est gérée par l'évaluation principale du projet ci-dessus.",
        "strategicImportanceLabel": "Importance stratégique à ce niveau (1–10)",
        "benefitLabel": "Bénéfice attendu à ce niveau (1–10)",
        "portfolioNotesLabel": "Note confidentielle / Briefing pour ce comité de direction",
        "portfolioNotesHelp": "Visible uniquement par les membres de ce niveau organisationnel. Invisible pour l'équipe projet.",
        "portfolioNotesPlaceholder": "ex. Point à l'ordre du jour du Conseil exécutif : Crédit supplémentaire requis.",
        "evaluationSavedAnnounce": "Évaluation de niveau enregistrée avec succès.",
        "promoteError": "Erreur lors de la promotion du projet.",
        "revokeError": "Erreur lors de la révocation de la promotion.",
        "evaluateError": "Erreur lors de l'enregistrement de l'évaluation.",
        "promotedAnnounce": "Projet transmis à {{unit}}.",
        "revokedAnnounce": "Transmission retirée.",
        "actionError": "L'action a échoué.",
        "origin": "Origine",
        "promotedAtBy": "{{date}} · {{name}}",
        "title": "Transmission et thèmes transversaux",
        "subtitle": "Les unités supérieures et les offices transversaux voient le projet avec ses risques, mais sans les mesures, et ne le modifient pas.",
        "chain": "Chaîne de transmission",
        "notPromoted": "non transmis",
        "promoteTo": "Transmettre à {{unit}}",
        "revoke": "Retirer la transmission",
        "topicsTitle": "Thèmes transversaux",
        "promoteExplain": "{{unit}} verra ensuite le projet avec ses données et ses risques (sans les mesures) et pourra l'évaluer ou le transmettre à son tour.",
        "comment": "Justification (facultatif)",
        "revokeExplain": "Votre transmission et toutes celles des niveaux supérieurs seront retirées. Les unités concernées ne verront ensuite plus le projet.",
        "confirm": "Confirmer"
    },
    "rollup": {
        "dashboardTitle": "Rollup et consolidation CAF : {{unitName}}",
        "dashboardSubtitle": "Évaluation consolidée sur {{count}} auto-évaluations de {{units}} unités organisationnelles",
        "weightedFteToggle": "Pondération par les effectifs (EPT)",
        "viewModeLabel": "Changer de vue",
        "chartView": "Graphique radar",
        "tableView": "Tableau (Accessible)",
        "loadedAnnounce": "Données rollup actualisées avec succès.",
        "noAssessmentsFound": "Aucune évaluation publiée trouvée dans la sous-arborescence de cette unité.",
        "radarChartTitle": "Profil consolidé des critères (Maturité CAF)",
        "rollupAverage": "Moyenne consolidée",
        "averageScore": "Moyenne",
        "insightsTitle": "Enseignements transversaux",
        "insightsSubtitle": "Points forts et écarts types sur l'ensemble des unités subordonnées",
        "topStrengthBadge": "Point fort principal",
        "topPotentialBadge": "Potentiel d'amélioration clé",
        "totalRemarksCount": "{{count}} constats qualitatifs (points forts et potentiels) consolidés",
        "tableCaption": "Métriques de rollup CAF par sous-critère",
        "subCriterionCol": "Sous-critère",
        "averageCol": "Moyenne",
        "minCol": "Min",
        "maxCol": "Max",
        "varianceCol": "Écart (Δ)",
        "assessmentsCountCol": "Nombre",
        "childUnits": "unités subordonnées",
        "titleV2": "{{unit}} : agrégat des {{children}}",
        "explain": "Pour chaque unité, c'est la dernière évaluation de l'année clôturée et partagée avec votre unité qui compte ; à défaut, la dernière évaluation antérieure. Chaque unité a le même poids ; les sous-critères non évalués ne sont pas pris en compte.",
        "year": "Année",
        "coverage": "Couverture : {{included}} sur {{total}} {{children}}",
        "unitsCaption": "Unités prises en compte",
        "unitCol": "Unité",
        "assessmentCol": "Évaluation",
        "totalCol": "Score global",
        "carriedOver": "repris de {{year}}",
        "notIncluded": "non incluse (aucune évaluation partagée)",
        "noChildUnits": "Cette unité n'a pas d'unités subordonnées.",
        "radarTitle": "Moyenne par critère",
        "totalMean": "Total {{value}} %",
        "average": "Moyenne",
        "insights": "Points saillants",
        "strongest": "Moyenne la plus élevée",
        "weakest": "Moyenne la plus basse",
        "trend": "Évolution du score global",
        "total": "Total",
        "subCriteriaTitle": "Sous-critères",
        "spreadCol": "Dispersion (σ)",
        "nCol": "Unités",
        "remarksTitle": "Remarques des unités",
        "remarkFilter": "Type de remarque",
        "potentials": "Potentiels",
        "strengths": "Points forts",
        "allRemarks": "Toutes",
        "noRemarks": "Aucune remarque.",
        "noAssessmentsFoundV2": "Aucune évaluation partagée par les {{children}} n'est disponible pour cette année."
    },
    "unitView": {
        "statuses": { "TOP_PRIORITY": "Priorité absolue", "ACTIVE": "Actif", "WATCHLIST": "Sous observation", "DEPRIORITIZED": "Reporté" },
        "categories": "Catégories propres",
        "savedAnnounce": "Évaluation enregistrée.",
        "title": "Vue {{unit}}",
        "confidential": "Confidentiel : visible uniquement par votre unité. L'unité d'origine et les autres niveaux ne voient pas ces informations.",
        "rank": "Rang",
        "status": "Statut dans le portefeuille",
        "statusNone": "Aucun statut",
        "notes": "Notes confidentielles",
        "lastUpdate": "Dernière modification {{date}} {{name}}",
        "saved": "Enregistré.",
        "error": "Échec de l'enregistrement.",
        "statusUnknown": "N'est plus défini",
        "notRated": "Non évalué",
        "confidentialOwn": "Confidentiel : visible uniquement pour la gestion de portefeuille et la direction de votre unité. Les unités supérieures ne voient pas ces indications.",
        "rankPlaceholder": "p. ex. 1",
        "saveView": "Enregistrer la vue",
        "newNote": "Nouvelle note",
        "notePlaceholder": "Nouvelle note pour votre unité …",
        "addNote": "Ajouter une note",
        "noteAddedAnnounce": "Note enregistrée.",
        "confirmDeleteNote": "Supprimer vraiment cette note ?",
        "noteDeletedAnnounce": "Note supprimée.",
        "deleteNote": "Supprimer la note",
        "loadingNotes": "Chargement des notes …",
        "noNotes": "Aucune note pour l'instant.",
        "unknownAuthor": "Inconnu",
        "legacyNote": "note antérieure"
    },
    "actions": {
        "reset": "Réinitialiser"
    },
    "assessmentLifecycle": {
        "statusFinal": "Clôturée",
        "statusSubmitted": "Soumise (externe)",
        "statusDraft": "Brouillon",
        "releasedByChild": "Partagée par {{unit}}",
        "releasedTo": "Partagée avec {{unit}}",
        "error": "L'action a échoué.",
        "unknownUnit": "Unité organisationnelle",
        "confidential": "Confidentiel (propre unité uniquement)",
        "finalize": "Clôturer",
        "finalizedAnnounce": "Évaluation clôturée.",
        "release": "Partager avec {{unit}}",
        "releasedAnnounce": "Évaluation partagée.",
        "withdraw": "Retirer le partage",
        "withdrawnAnnounce": "Partage retiré.",
        "reopen": "Rouvrir",
        "reopenedAnnounce": "Évaluation rouverte.",
        "hintNew": "Les nouvelles évaluations sont des brouillons et ne sont visibles que dans votre unité.",
        "hintDraft": "Une évaluation clôturée ne peut plus être modifiée et peut être partagée avec l'unité supérieure.",
        "hintFinal": "Après le partage, {{unit}} voit l'évaluation complète, remarques comprises. Les niveaux supérieurs ne la voient pas individuellement ; elle entre de manière anonyme dans la moyenne générale.",
        "hintForeign": "Partagée par une unité subordonnée. Lecture seule.",
        "saveFirst": "Veuillez d'abord enregistrer, puis clôturer."
    },
    "comparison": {
        "title": "Comparaison avec d'autres unités",
        "intro": "Moyennes uniquement, état {{year}}. Chaque unité compte de la même façon.",
        "directColumn": "Unités directement sous {{group}}",
        "overallColumn": "Toutes les unités sous {{root}}",
        "explainDirect": "Unités directement sous {{group}} : y compris votre unité, si elle a été partagée ; affichées à partir de {{min}} unités. Base : {{count}} unités sur {{total}}.",
        "explainDirectTop": "Unités directement sous {{group}} : votre propre évaluation n'est pas prise en compte. Base : {{count}} unités sur {{total}}.",
        "explainOverall": "Toutes les unités sous {{root}} : tous niveaux confondus, sans {{root}}, en pour cent entiers. Base : {{count}} unités sur {{total}}.",
        "tooFew": "Trop peu d'unités directement sous {{group}} pour une comparaison (au moins {{min}}).",
        "noReleases": "Aucune évaluation partagée pour l'instant par les unités directement sous {{group}}.",
        "overallTooFew": "Pas encore assez d'évaluations partagées pour une moyenne générale. La comparaison se limite aux unités directes.",
        "caption": "Propres valeurs par rapport aux moyennes",
        "criterion": "Critère",
        "own": "Propre unité",
        "difference": "Différence",
        "total": "Total"
    },
    "topics": {
        "validationRequired": "Le nom et l'unité responsable sont obligatoires.",
        "savedAnnounce": "Thème transversal enregistré.",
        "saveError": "Échec de l'enregistrement.",
        "confirmDelete": "Supprimer le thème transversal «{{name}}» ? Il sera retiré de tous les projets et l'unité responsable perdra l'accès.",
        "deletedAnnounce": "Thème transversal supprimé.",
        "deleteError": "La suppression a échoué.",
        "title": "Thèmes transversaux",
        "intro": "Catégories transversales à la hiérarchie avec une unité responsable, p. ex. informatique ou durabilité. Elles apparaissent comme catégorie dans toutes les unités. Lorsque la gestion de portefeuille attribue un projet à un thème transversal, il devient visible pour l'unité responsable (données du projet et risques, sans mesures).",
        "add": "Créer un thème",
        "empty": "Aucun thème transversal défini pour l'instant.",
        "owner": "Responsable",
        "inactive": "désactivé",
        "editNamed": "Modifier {{name}}",
        "activate": "Activer",
        "deactivate": "Désactiver",
        "deleteNamed": "Supprimer {{name}}",
        "edit": "Modifier le thème",
        "name": "Nom",
        "ownerUnit": "Unité responsable",
        "ownerChangeHint": "L'accès à tous les projets de ce thème est transféré à la nouvelle unité.",
        "description": "Description",
        "color": "Couleur"
    },
    "unitCategories": {
        "sectionTitle": "Catégories : {{unit}}",
        "intro": "Les catégories propres ne sont visibles que pour votre unité et servent à classer, à filtrer et aux feuilles de route ; elles ne partagent rien.",
        "error": "L'action a échoué.",
        "empty": "Aucune catégorie propre pour l'instant.",
        "addedAnnounce": "Catégorie créée.",
        "updatedAnnounce": "Catégorie enregistrée.",
        "deletedAnnounce": "Catégorie supprimée.",
        "colorFor": "Couleur de {{name}}",
        "nameFor": "Nom de {{name}}",
        "confirmDelete": "Supprimer la catégorie «{{name}}» ? Elle sera aussi retirée des projets.",
        "deleteNamed": "Supprimer {{name}}",
        "newColor": "Couleur de la nouvelle catégorie",
        "newName": "Nom de la nouvelle catégorie",
        "placeholder": "p. ex. objectif de législature 3",
        "add": "Ajouter",
        "topicsTitle": "Thèmes transversaux",
        "topicsIntro": "Définis par le mandant et disponibles comme catégorie dans toutes les unités. Leur attribution rend un projet visible pour l'unité responsable.",
        "topicOwner": "responsable : {{unit}}"
    },
    "unitStatuses": {
        "sectionTitle": "Statut dans le portefeuille : {{unit}}",
        "intro": "Votre unité classe les projets dans sa vue confidentielle à l'aide de ces statuts. Les autres unités ne les voient pas.",
        "customHint": "Votre unité utilise ses propres statuts.",
        "defaultHint": "Les statuts par défaut s'appliquent actuellement ; enregistrer des modifications crée votre propre liste.",
        "nameFor": "Nom du statut {{position}}",
        "moveUp": "Monter {{name}}",
        "moveDown": "Descendre {{name}}",
        "remove": "Retirer {{name}}",
        "newName": "Nom du nouveau statut",
        "placeholder": "p. ex. À examiner par la direction",
        "add": "Ajouter",
        "reset": "Utiliser les statuts par défaut",
        "discard": "Annuler les modifications",
        "save": "Enregistrer les statuts",
        "savedAnnounce": "Statuts enregistrés.",
        "savedCleared_one": "Statuts enregistrés. 1 projet n'a plus de statut.",
        "savedCleared_other": "Statuts enregistrés. {{count}} projets n'ont plus de statut.",
        "error": "L'enregistrement a échoué.",
        "nameMissing": "Chaque statut doit avoir un nom.",
        "confirmRemove": "Les statuts retirés ({{list}}) seront supprimés des projets de votre unité. Continuer ?",
        "confirmReset": "Revenir aux statuts par défaut ? Les projets ayant un statut propre le perdront."
    },
    "sharingBadge": {
        "receivedFrom": "Reçu de {{unit}}",
        "receivedTopic": "Reçu via le thème transversal {{topic}}",
        "promotedTo": "Transmis à {{unit}}",
        "sharedTopic": "Partagé avec {{unit}} (thème transversal {{topic}})"
    },
    "topicShare": {
        "title": "Confirmer le partage avec les offices transversaux",
        "gainAccess": "Obtiennent un aperçu de ce projet (données du projet et risques, sans mesures) :",
        "loseAccess": "Perdent l'aperçu :",
        "confirm": "Confirmer et enregistrer"
    }
};
